/**
 * This file is generated by `pnpm codegen` from the OpenAPI spec, DO NOT EDIT.
 */

export type OperationRef = {
  name: string
  file: string
  hasBody: boolean
}

export type ResourceCatalogEntry = {
  key: string
  path: string
  scope: 'company' | 'person' | 'loan' | 'global'
  pathParams: Array<string>
  label: { singular: string; plural: string }
  idParam?: string
  operations: {
    list?: OperationRef
    get?: OperationRef
    create?: OperationRef
    update?: OperationRef
    delete?: OperationRef
    actions?: Array<OperationRef>
  }
  formSchemas?: {
    response?: string
    request?: string
    updateRequest?: string
  }
  companyAmbiguous?: boolean
}

export const resourceCatalog: { [key: string]: ResourceCatalogEntry } = {
  _3rdpartyByoTwilio: {
    key: '_3rdpartyByoTwilio',
    path: '/companies/{companyId}/3rdparty/byo-twilio',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Byo Twilio',
      plural: 'Byo Twilios',
    },
    operations: {
      get: {
        name: 'getByoTwilio',
        file: 'company',
        hasBody: false,
      },
      update: {
        name: 'updateByoTwilio',
        file: 'company',
        hasBody: true,
      },
      actions: [
        {
          name: 'syncByoTwilio',
          file: 'company',
          hasBody: true,
        },
      ],
    },
    formSchemas: {
      response: '_3rdpartyByoTwilioResponse',
      request: '_3rdpartyByoTwilioRequest',
      updateRequest: '_3rdpartyByoTwilioUpdateRequest',
    },
  },
  _3rdpartyPlaidCredentials: {
    key: '_3rdpartyPlaidCredentials',
    path: '/3rdparty/{companyId}/plaid/credentials',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Credential',
      plural: 'Credentials',
    },
    operations: {
      create: {
        name: 'thirdPartyUpdatePlaidCredentials',
        file: 'company',
        hasBody: true,
      },
    },
    formSchemas: {
      request: '_3rdpartyPlaidCredentialsRequest',
    },
  },
  _3rdpartySendgridCredentials: {
    key: '_3rdpartySendgridCredentials',
    path: '/companies/{companyId}/3rdparty/sendgrid/credentials',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Credential',
      plural: 'Credentials',
    },
    operations: {
      create: {
        name: 'updateSendgridCredentials',
        file: 'company',
        hasBody: true,
      },
    },
    formSchemas: {
      request: '_3rdpartySendgridCredentialsRequest',
    },
  },
  _3rdpartyTwilioProvision: {
    key: '_3rdpartyTwilioProvision',
    path: '/companies/{companyId}/3rdparty/twilio/provision',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Provision',
      plural: 'Provisions',
    },
    operations: {
      create: {
        name: 'provisionCompanyTwilio',
        file: 'company',
        hasBody: true,
      },
    },
    formSchemas: {
      request: '_3rdpartyTwilioProvisionRequest',
    },
  },
  activeEscalations: {
    key: 'activeEscalations',
    path: '/companies/{companyId}/active-escalations',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Active Escalation',
      plural: 'Active Escalations',
    },
    operations: {
      list: {
        name: 'internalCaseOpenEscalationsGetByCompany',
        file: 'cases',
        hasBody: false,
      },
      actions: [
        {
          name: 'caseOpenEscalationsGetByCompany',
          file: 'cases',
          hasBody: false,
        },
      ],
    },
    formSchemas: {
      response: 'activeEscalationsResponse',
    },
  },
  advances: {
    key: 'advances',
    path: '/people/{personId}/loans/{loanId}/advances',
    scope: 'loan',
    pathParams: ['personId', 'loanId'],
    label: {
      singular: 'Advance',
      plural: 'Advances',
    },
    idParam: 'advanceId',
    operations: {
      list: {
        name: 'getLoanAdvances',
        file: 'api-public',
        hasBody: false,
      },
      get: {
        name: 'getLoanAdvance',
        file: 'api-public',
        hasBody: false,
      },
      create: {
        name: 'createLoanAdvance',
        file: 'api-public',
        hasBody: true,
      },
      update: {
        name: 'updateLoanAdvance',
        file: 'api-public',
        hasBody: true,
      },
    },
    formSchemas: {
      response: 'advancesResponse',
      request: 'advancesRequest',
    },
  },
  agentDashboardTools: {
    key: 'agentDashboardTools',
    path: '/companies/{companyId}/people/{personId}/loans/{loanId}/agent-dashboard-tools',
    scope: 'loan',
    pathParams: ['companyId', 'personId', 'loanId'],
    label: {
      singular: 'Agent Dashboard Tool',
      plural: 'Agent Dashboard Tools',
    },
    operations: {
      list: {
        name: 'internalLoanAgentDashboardToolsGet',
        file: 'api-internal',
        hasBody: false,
      },
      actions: [
        {
          name: 'loanAgentDashboardToolsGet',
          file: 'api-public',
          hasBody: false,
        },
      ],
    },
    formSchemas: {
      response: 'agentDashboardToolsResponse',
    },
  },
  aiCaseSummarizerPromptHash: {
    key: 'aiCaseSummarizerPromptHash',
    path: '/ai/case-summarizer/prompt-hash',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Prompt Hash',
      plural: 'Prompt Hashes',
    },
    operations: {
      create: {
        name: 'caseSummarizerGeneratePromptHash',
        file: 'ai-case-summarizer',
        hasBody: true,
      },
    },
    formSchemas: {
      request: 'aiCaseSummarizerPromptHashRequest',
    },
    companyAmbiguous: true,
  },
  aiCaseSummarizerResults: {
    key: 'aiCaseSummarizerResults',
    path: '/ai/case-summarizer/results',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Result',
      plural: 'Results',
    },
    idParam: 'aICaseSummarizerResultId',
    operations: {
      get: {
        name: 'caseSummarizerResultsGet',
        file: 'ai-case-summarizer',
        hasBody: false,
      },
      create: {
        name: 'caseSummarizerResultsCreate',
        file: 'ai-case-summarizer',
        hasBody: true,
      },
      actions: [
        {
          name: 'caseSummarizerResultsUserFeedbackGet',
          file: 'ai-case-summarizer',
          hasBody: false,
        },
        {
          name: 'caseSummarizerResultsUserFeedbackSet',
          file: 'ai-case-summarizer',
          hasBody: true,
        },
        {
          name: 'caseSummarizerResultsUserFeedbackDelete',
          file: 'ai-case-summarizer',
          hasBody: false,
        },
      ],
    },
    formSchemas: {
      response: 'aiCaseSummarizerResultsResponse',
      request: 'aiCaseSummarizerResultsRequest',
    },
    companyAmbiguous: true,
  },
  amortize: {
    key: 'amortize',
    path: '/amortize',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Amortize',
      plural: 'Amortizes',
    },
    operations: {
      create: {
        name: 'amortizationGet',
        file: 'api-public',
        hasBody: true,
      },
    },
    companyAmbiguous: true,
  },
  apiVersions: {
    key: 'apiVersions',
    path: '/api-versions',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Api Version',
      plural: 'Api Versions',
    },
    operations: {
      list: {
        name: 'apiVersionsGetAll',
        file: 'api-versioning',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'apiVersionsResponse',
    },
    companyAmbiguous: true,
  },
  appDomains: {
    key: 'appDomains',
    path: '/companies/{companyId}/app-domains',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'App Domain',
      plural: 'App Domains',
    },
    idParam: 'companyAppDomainId',
    operations: {
      list: {
        name: 'companyAppDomainGetAll',
        file: 'company',
        hasBody: false,
      },
      get: {
        name: 'companyAppDomainGet',
        file: 'company',
        hasBody: false,
      },
      create: {
        name: 'companyAppDomainPost',
        file: 'company',
        hasBody: true,
      },
      update: {
        name: 'companyAppDomainPut',
        file: 'company',
        hasBody: true,
      },
    },
    formSchemas: {
      response: 'appDomainsResponse',
      request: 'appDomainsRequest',
    },
  },
  authEndsession: {
    key: 'authEndsession',
    path: '/auth/endsession',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Endsession',
      plural: 'Endsessions',
    },
    operations: {
      create: {
        name: 'endSession',
        file: 'api-internal',
        hasBody: true,
      },
    },
    formSchemas: {
      request: 'authEndsessionRequest',
    },
    companyAmbiguous: true,
  },
  authExchangeToken: {
    key: 'authExchangeToken',
    path: '/auth/exchange-token',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Exchange Token',
      plural: 'Exchange Tokens',
    },
    operations: {
      create: {
        name: 'exchangeTokenCreate',
        file: 'security',
        hasBody: true,
      },
    },
    formSchemas: {
      request: 'authExchangeTokenRequest',
    },
    companyAmbiguous: true,
  },
  authPassword: {
    key: 'authPassword',
    path: '/auth/password',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Password',
      plural: 'Passwords',
    },
    operations: {
      create: {
        name: 'passwordPost',
        file: 'api-internal',
        hasBody: true,
      },
    },
    companyAmbiguous: true,
  },
  authPermissions: {
    key: 'authPermissions',
    path: '/auth/permissions',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Permission',
      plural: 'Permissions',
    },
    operations: {
      list: {
        name: 'userPermissions_get',
        file: 'api-internal',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'authPermissionsResponse',
    },
    companyAmbiguous: true,
  },
  authSamlCallback: {
    key: 'authSamlCallback',
    path: '/companies/{companyId}/auth/saml/callback',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Callback',
      plural: 'Callbacks',
    },
    operations: {
      create: {
        name: 'idpInitiated',
        file: 'api-internal',
        hasBody: true,
      },
    },
  },
  authSamlHelp: {
    key: 'authSamlHelp',
    path: '/companies/{companyId}/auth/saml/help',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Help',
      plural: 'Helps',
    },
    operations: {
      list: {
        name: 'idpSetupHelp',
        file: 'api-internal',
        hasBody: false,
      },
    },
  },
  authSamlLogin: {
    key: 'authSamlLogin',
    path: '/companies/{companyId}/auth/saml/login',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Login',
      plural: 'Logins',
    },
    operations: {
      list: {
        name: 'spInitiated',
        file: 'api-internal',
        hasBody: false,
      },
    },
  },
  authSamlMetadata: {
    key: 'authSamlMetadata',
    path: '/companies/{companyId}/auth/saml/metadata',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Metadatum',
      plural: 'Metadata',
    },
    operations: {
      actions: [
        {
          name: 'spMetadataXml',
          file: 'api-internal',
          hasBody: false,
        },
      ],
    },
  },
  authSendOneTimeCode: {
    key: 'authSendOneTimeCode',
    path: '/companies/{companyId}/auth/send-one-time-code',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Send One Time Code',
      plural: 'Send One Time Codes',
    },
    operations: {
      create: {
        name: 'sendOneTimeCode',
        file: 'security',
        hasBody: true,
      },
    },
    formSchemas: {
      request: 'authSendOneTimeCodeRequest',
    },
  },
  authToken: {
    key: 'authToken',
    path: '/auth/token',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Token',
      plural: 'Tokens',
    },
    operations: {
      create: {
        name: 'validateAndSendToken',
        file: 'api-internal',
        hasBody: true,
      },
      update: {
        name: 'renewJwtToken',
        file: 'api-internal',
        hasBody: false,
      },
      actions: [
        {
          name: 'logout',
          file: 'api-internal',
          hasBody: false,
        },
        {
          name: 'shortLivedToken',
          file: 'api-internal',
          hasBody: true,
        },
      ],
    },
    companyAmbiguous: true,
  },
  authUser: {
    key: 'authUser',
    path: '/auth/user',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'User',
      plural: 'Users',
    },
    operations: {
      list: {
        name: 'userInfoGet',
        file: 'api-internal',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'authUserResponse',
    },
    companyAmbiguous: true,
  },
  autopay: {
    key: 'autopay',
    path: '/companies/{companyId}/people/{personId}/loans/{loanId}/autopay',
    scope: 'loan',
    pathParams: ['companyId', 'personId', 'loanId'],
    label: {
      singular: 'Autopay',
      plural: 'Autopays',
    },
    operations: {
      get: {
        name: 'internalLoanAutopayGet',
        file: 'api-internal',
        hasBody: false,
      },
      create: {
        name: 'internalLoanAutopayPost',
        file: 'api-internal',
        hasBody: true,
      },
      update: {
        name: 'internalLoanAutopayPut',
        file: 'api-internal',
        hasBody: true,
      },
      actions: [
        {
          name: 'internalLoanAutopayDelete',
          file: 'api-internal',
          hasBody: false,
        },
        {
          name: 'internalLoanAutopayUpdateExpectedPaymentAmount',
          file: 'api-internal',
          hasBody: true,
        },
        {
          name: 'internalLoanAutopayCancelPayments',
          file: 'api-internal',
          hasBody: true,
        },
        {
          name: 'internalLoanAutopayReschedulePayments',
          file: 'api-internal',
          hasBody: true,
        },
        {
          name: 'internalLoanAutopayCreateNextAutopay',
          file: 'api-internal',
          hasBody: true,
        },
        {
          name: 'loanAutopayGet',
          file: 'api-public',
          hasBody: false,
        },
        {
          name: 'loanAutopayPost',
          file: 'api-public',
          hasBody: true,
        },
        {
          name: 'loanAutopayPut',
          file: 'api-public',
          hasBody: true,
        },
        {
          name: 'loanAutopayDelete',
          file: 'api-public',
          hasBody: false,
        },
      ],
    },
  },
  autopays: {
    key: 'autopays',
    path: '/companies/{companyId}/autopays',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Autopay',
      plural: 'Autopays',
    },
    operations: {
      list: {
        name: 'autopayGetAllInternalCompany',
        file: 'api-internal',
        hasBody: false,
      },
      actions: [
        {
          name: 'autopayGetAllInternal',
          file: 'api-internal',
          hasBody: false,
        },
      ],
    },
    formSchemas: {
      response: 'autopaysResponse',
    },
  },
  balances: {
    key: 'balances',
    path: '/companies/{companyId}/people/{personId}/loans/{loanId}/balances',
    scope: 'loan',
    pathParams: ['companyId', 'personId', 'loanId'],
    label: {
      singular: 'Balance',
      plural: 'Balances',
    },
    operations: {
      list: {
        name: 'internalLoanBalancesGet',
        file: 'api-internal',
        hasBody: false,
      },
      actions: [
        {
          name: 'loanBalancesGet',
          file: 'api-public',
          hasBody: false,
        },
      ],
    },
    formSchemas: {
      response: 'balancesResponse',
    },
  },
  binNumbers: {
    key: 'binNumbers',
    path: '/bin-numbers',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Bin Number',
      plural: 'Bin Numbers',
    },
    operations: {
      create: {
        name: 'getBinNumber',
        file: 'api-internal',
        hasBody: true,
      },
    },
    formSchemas: {
      request: 'binNumbersRequest',
    },
    companyAmbiguous: true,
  },
  bootstrap: {
    key: 'bootstrap',
    path: '/bootstrap',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Bootstrap',
      plural: 'Bootstraps',
    },
    operations: {
      list: {
        name: 'bootstrap',
        file: 'frontend',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'bootstrapResponse',
    },
    companyAmbiguous: true,
  },
  bulkOperations: {
    key: 'bulkOperations',
    path: '/companies/{companyId}/bulk-operations',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Bulk Operation',
      plural: 'Bulk Operations',
    },
    idParam: 'supercaseBulkOperationId',
    operations: {
      list: {
        name: 'internalSupercaseBulkOperationList',
        file: 'supercases',
        hasBody: false,
      },
      get: {
        name: 'internalSupercaseBulkOperationGet',
        file: 'supercases',
        hasBody: false,
      },
    },
  },
  businessDays: {
    key: 'businessDays',
    path: '/business-days',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Business Day',
      plural: 'Business Days',
    },
    operations: {
      create: {
        name: 'populateBusinessDays',
        file: 'api-internal',
        hasBody: true,
      },
    },
    formSchemas: {
      request: 'businessDaysRequest',
    },
    companyAmbiguous: true,
  },
  cardIssuers: {
    key: 'cardIssuers',
    path: '/companies/{companyId}/card-issuers',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Card Issuer',
      plural: 'Card Issuers',
    },
    idParam: 'cardIssuerId',
    operations: {
      list: {
        name: 'internalCardIssuersList',
        file: 'card-issuers',
        hasBody: false,
      },
      get: {
        name: 'internalCardIssuerGet',
        file: 'card-issuers',
        hasBody: false,
      },
      create: {
        name: 'internalCardIssuerCreate',
        file: 'card-issuers',
        hasBody: true,
      },
      update: {
        name: 'internalCardIssuerUpdate',
        file: 'card-issuers',
        hasBody: true,
      },
      delete: {
        name: 'internalCardIssuerDelete',
        file: 'card-issuers',
        hasBody: false,
      },
      actions: [
        {
          name: 'cardIssuersList',
          file: 'card-issuers',
          hasBody: false,
        },
        {
          name: 'cardIssuerGet',
          file: 'card-issuers',
          hasBody: false,
        },
        {
          name: 'cardIssuerCreate',
          file: 'card-issuers',
          hasBody: true,
        },
        {
          name: 'cardIssuerUpdate',
          file: 'card-issuers',
          hasBody: true,
        },
        {
          name: 'cardIssuerDelete',
          file: 'card-issuers',
          hasBody: false,
        },
      ],
    },
  },
  cards: {
    key: 'cards',
    path: '/people/{personId}/loans/{loanId}/cards',
    scope: 'loan',
    pathParams: ['personId', 'loanId'],
    label: {
      singular: 'Card',
      plural: 'Cards',
    },
    idParam: 'cardId',
    operations: {
      list: {
        name: 'cardsList',
        file: 'card-issuers',
        hasBody: false,
      },
      get: {
        name: 'cardGet',
        file: 'card-issuers',
        hasBody: false,
      },
      create: {
        name: 'cardCreate',
        file: 'card-issuers',
        hasBody: true,
      },
      update: {
        name: 'cardUpdate',
        file: 'card-issuers',
        hasBody: true,
      },
    },
  },
  caseDoNotInteracts: {
    key: 'caseDoNotInteracts',
    path: '/people/{personId}/cases/{caseId}/do-not-interacts',
    scope: 'person',
    pathParams: ['personId', 'caseId'],
    label: {
      singular: 'Do Not Interact',
      plural: 'Do Not Interacts',
    },
    idParam: 'doNotInteractId',
    operations: {
      list: {
        name: 'caseDoNotInteractGetAll',
        file: 'api-public',
        hasBody: false,
      },
      get: {
        name: 'doNotInteractGetById',
        file: 'api-public',
        hasBody: false,
      },
      create: {
        name: 'doNotInteractCreate',
        file: 'api-public',
        hasBody: true,
      },
      update: {
        name: 'doNotInteractUpdate',
        file: 'api-public',
        hasBody: true,
      },
      delete: {
        name: 'doNotInteractDelete',
        file: 'api-public',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'caseDoNotInteractsResponse',
      request: 'caseDoNotInteractsRequest',
    },
  },
  caseEscalations: {
    key: 'caseEscalations',
    path: '/companies/{companyId}/cases/{caseId}/escalations',
    scope: 'company',
    pathParams: ['companyId', 'caseId'],
    label: {
      singular: 'Escalation',
      plural: 'Escalations',
    },
    operations: {
      list: {
        name: 'internalGetCaseEscalation',
        file: 'cases',
        hasBody: false,
      },
      create: {
        name: 'internalCreateCaseEscalation',
        file: 'cases',
        hasBody: true,
      },
    },
    formSchemas: {
      response: 'caseEscalationsResponse',
      request: 'caseEscalationsRequest',
    },
  },
  caseNotes: {
    key: 'caseNotes',
    path: '/people/{personId}/cases/{caseId}/notes',
    scope: 'person',
    pathParams: ['personId', 'caseId'],
    label: {
      singular: 'Note',
      plural: 'Notes',
    },
    idParam: 'noteId',
    operations: {
      list: {
        name: 'listCaseNotes',
        file: 'api-public',
        hasBody: false,
      },
      get: {
        name: 'getCaseNote',
        file: 'api-public',
        hasBody: false,
      },
      create: {
        name: 'createCaseNote',
        file: 'api-public',
        hasBody: true,
      },
      update: {
        name: 'updateCaseNote',
        file: 'api-public',
        hasBody: true,
      },
    },
    formSchemas: {
      response: 'caseNotesResponse',
      request: 'caseNotesRequest',
    },
  },
  cases: {
    key: 'cases',
    path: '/companies/{companyId}/cases',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Case',
      plural: 'Cases',
    },
    idParam: 'caseId',
    operations: {
      list: {
        name: 'internalListCasesByCompany',
        file: 'cases',
        hasBody: false,
      },
      get: {
        name: 'internalUnboundGetCaseById',
        file: 'cases',
        hasBody: false,
      },
      update: {
        name: 'internalUnboundCaseUpdate',
        file: 'cases',
        hasBody: true,
      },
      delete: {
        name: 'internalUnboundRemoveCaseAssociation',
        file: 'cases',
        hasBody: false,
      },
      actions: [
        {
          name: 'internalUnboundAddCaseAssociation',
          file: 'cases',
          hasBody: true,
        },
        {
          name: 'listCasesByCompany',
          file: 'cases',
          hasBody: false,
        },
      ],
    },
  },
  caseTypes: {
    key: 'caseTypes',
    path: '/companies/{companyId}/case-types',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Case Type',
      plural: 'Case Types',
    },
    idParam: 'caseTypeId',
    operations: {
      list: {
        name: 'internalListCaseTypes',
        file: 'cases',
        hasBody: false,
      },
      get: {
        name: 'getCaseTypeById',
        file: 'cases',
        hasBody: false,
      },
      create: {
        name: 'createCaseType',
        file: 'cases',
        hasBody: true,
      },
      update: {
        name: 'updateCaseType',
        file: 'cases',
        hasBody: true,
      },
      actions: [
        {
          name: 'internalCreateCaseTypeSmartReviewTasks',
          file: 'cases',
          hasBody: false,
        },
        {
          name: 'listCaseType',
          file: 'cases',
          hasBody: false,
        },
        {
          name: 'caseTypeAddAssociation',
          file: 'cases',
          hasBody: false,
        },
        {
          name: 'caseTypeRemoveAssociation',
          file: 'cases',
          hasBody: false,
        },
        {
          name: 'createSmartReviewTasks',
          file: 'cases',
          hasBody: false,
        },
      ],
    },
    formSchemas: {
      response: 'caseTypesResponse',
      request: 'caseTypesRequest',
    },
  },
  caseWorkflowSteps: {
    key: 'caseWorkflowSteps',
    path: '/companies/{companyId}/people/{personId}/cases/{caseId}/workflow/steps',
    scope: 'person',
    pathParams: ['companyId', 'personId', 'caseId'],
    label: {
      singular: 'Step',
      plural: 'Steps',
    },
    idParam: 'workflowStepId',
    operations: {
      update: {
        name: 'updateWorkflowStep',
        file: 'workflows',
        hasBody: true,
      },
    },
    formSchemas: {
      request: 'caseWorkflowStepsRequest',
    },
  },
  caseWorkflowStepWorkitems: {
    key: 'caseWorkflowStepWorkitems',
    path: '/companies/{companyId}/people/{personId}/cases/{caseId}/workflow/steps/{workflowStepId}/workitems',
    scope: 'person',
    pathParams: ['companyId', 'personId', 'caseId', 'workflowStepId'],
    label: {
      singular: 'Workitem',
      plural: 'Workitems',
    },
    idParam: 'workflowWorkitemId',
    operations: {
      update: {
        name: 'updateWorkflowWorkitem',
        file: 'workflows',
        hasBody: true,
      },
    },
    formSchemas: {
      request: 'caseWorkflowStepWorkitemsRequest',
    },
  },
  collectionAgencies: {
    key: 'collectionAgencies',
    path: '/companies/{companyId}/collection-agencies',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Collection Agency',
      plural: 'Collection Agencies',
    },
    idParam: 'collectionAgencyId',
    operations: {
      list: {
        name: 'collectionAgenciesList',
        file: 'collection-agencies',
        hasBody: false,
      },
      get: {
        name: 'collectionAgencyGet',
        file: 'collection-agencies',
        hasBody: false,
      },
      create: {
        name: 'collectionAgencyCreate',
        file: 'collection-agencies',
        hasBody: true,
      },
      update: {
        name: 'collectionAgencyUpdate',
        file: 'collection-agencies',
        hasBody: true,
      },
      delete: {
        name: 'collectionAgencyDelete',
        file: 'collection-agencies',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'collectionAgenciesResponse',
      request: 'collectionAgenciesRequest',
    },
  },
  collectionAgency: {
    key: 'collectionAgency',
    path: '/people/{personId}/loans/{loanId}/collection-agency',
    scope: 'loan',
    pathParams: ['personId', 'loanId'],
    label: {
      singular: 'Collection Agency',
      plural: 'Collection Agencies',
    },
    operations: {
      list: {
        name: 'collectionAgencyLoanDetailsGet',
        file: 'collection-agencies',
        hasBody: false,
      },
      create: {
        name: 'collectionAgencyLoanDetailsUpdate',
        file: 'collection-agencies',
        hasBody: true,
      },
      actions: [
        {
          name: 'collectionAgencyLoanDetailsUnassign',
          file: 'collection-agencies',
          hasBody: false,
        },
      ],
    },
    formSchemas: {
      response: 'collectionAgencyResponse',
      request: 'collectionAgencyRequest',
    },
  },
  communicatorPreview: {
    key: 'communicatorPreview',
    path: '/communicator/preview',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Preview',
      plural: 'Previews',
    },
    operations: {
      create: {
        name: 'preview',
        file: 'communicator',
        hasBody: true,
      },
    },
    formSchemas: {
      request: 'communicatorPreviewRequest',
    },
    companyAmbiguous: true,
  },
  communicatorPreviewFreeFormEmail: {
    key: 'communicatorPreviewFreeFormEmail',
    path: '/communicator/preview-free-form-email',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Preview Free Form Email',
      plural: 'Preview Free Form Emails',
    },
    operations: {
      create: {
        name: 'previewFreeFormEmail',
        file: 'communicator',
        hasBody: true,
      },
    },
    formSchemas: {
      request: 'communicatorPreviewFreeFormEmailRequest',
    },
    companyAmbiguous: true,
  },
  communicatorReceive: {
    key: 'communicatorReceive',
    path: '/companies/{companyId}/communicator/receive',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Receive',
      plural: 'Receives',
    },
    operations: {
      create: {
        name: 'internalHandleReceive',
        file: 'communicator',
        hasBody: true,
      },
      actions: [
        {
          name: 'handleReceive',
          file: 'communicator',
          hasBody: true,
        },
      ],
    },
  },
  communicatorRender: {
    key: 'communicatorRender',
    path: '/companies/{companyId}/communicator/render',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Render',
      plural: 'Renders',
    },
    operations: {
      create: {
        name: 'internalRender',
        file: 'communicator',
        hasBody: true,
      },
      actions: [
        {
          name: 'render',
          file: 'communicator',
          hasBody: true,
        },
      ],
    },
    formSchemas: {
      request: 'communicatorRenderRequest',
    },
  },
  communicatorRenderToDocument: {
    key: 'communicatorRenderToDocument',
    path: '/companies/{companyId}/communicator/render-to-document',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Render To Document',
      plural: 'Render To Documents',
    },
    operations: {
      create: {
        name: 'internalRenderToDocument',
        file: 'communicator',
        hasBody: true,
      },
      actions: [
        {
          name: 'renderToDocument',
          file: 'communicator',
          hasBody: true,
        },
      ],
    },
    formSchemas: {
      request: 'communicatorRenderToDocumentRequest',
    },
  },
  communicatorResend: {
    key: 'communicatorResend',
    path: '/communicator/resend',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Resend',
      plural: 'Resends',
    },
    operations: {
      create: {
        name: 'resend',
        file: 'communicator',
        hasBody: true,
      },
    },
    formSchemas: {
      request: 'communicatorResendRequest',
    },
    companyAmbiguous: true,
  },
  communicatorSend: {
    key: 'communicatorSend',
    path: '/companies/{companyId}/communicator/send',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Send',
      plural: 'Sends',
    },
    operations: {
      create: {
        name: 'internalHandleSend',
        file: 'communicator',
        hasBody: true,
      },
      actions: [
        {
          name: 'handleSend',
          file: 'communicator',
          hasBody: true,
        },
      ],
    },
    formSchemas: {
      request: 'communicatorSendRequest',
    },
  },
  communicatorSendConfirmationCode: {
    key: 'communicatorSendConfirmationCode',
    path: '/communicator/send-confirmation-code',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Send Confirmation Code',
      plural: 'Send Confirmation Codes',
    },
    operations: {
      create: {
        name: 'sendConfirmationCode',
        file: 'communicator',
        hasBody: true,
      },
    },
    formSchemas: {
      request: 'communicatorSendConfirmationCodeRequest',
    },
    companyAmbiguous: true,
  },
  communicatorSendFreeFormEmail: {
    key: 'communicatorSendFreeFormEmail',
    path: '/communicator/send-free-form-email',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Send Free Form Email',
      plural: 'Send Free Form Emails',
    },
    operations: {
      create: {
        name: 'sendFreeFormEmail',
        file: 'communicator',
        hasBody: true,
      },
    },
    formSchemas: {
      request: 'communicatorSendFreeFormEmailRequest',
    },
    companyAmbiguous: true,
  },
  communicatorSendTemplatedEmail: {
    key: 'communicatorSendTemplatedEmail',
    path: '/companies/{companyId}/communicator/send-templated-email',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Send Templated Email',
      plural: 'Send Templated Emails',
    },
    operations: {
      create: {
        name: 'sendTemplatedEmailHandler',
        file: 'communicator',
        hasBody: true,
      },
    },
    formSchemas: {
      request: 'communicatorSendTemplatedEmailRequest',
    },
  },
  communicatorSubjects: {
    key: 'communicatorSubjects',
    path: '/companies/{companyId}/communicator/subjects',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Subject',
      plural: 'Subjects',
    },
    idParam: 'subject',
    operations: {
      list: {
        name: 'internalSubjectDescriptorsList',
        file: 'communicator',
        hasBody: false,
      },
      get: {
        name: 'internalSubjectDescriptorGetBySubject',
        file: 'communicator',
        hasBody: false,
      },
      update: {
        name: 'internalSubjectDescriptorUpdate',
        file: 'communicator',
        hasBody: true,
      },
      actions: [
        {
          name: 'subjectDescriptorsList',
          file: 'communicator',
          hasBody: false,
        },
        {
          name: 'subjectDescriptorGetBySubject',
          file: 'communicator',
          hasBody: false,
        },
        {
          name: 'subjectDescriptorUpdate',
          file: 'communicator',
          hasBody: true,
        },
      ],
    },
    formSchemas: {
      response: 'communicatorSubjectsResponse',
      request: 'communicatorSubjectsRequest',
    },
  },
  communicatorTemplatedescriptors: {
    key: 'communicatorTemplatedescriptors',
    path: '/companies/{companyId}/communicator/templatedescriptors',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Templatedescriptor',
      plural: 'Templatedescriptors',
    },
    idParam: 'descriptorId',
    operations: {
      list: {
        name: 'internalListTemplateDescriptors',
        file: 'communicator',
        hasBody: false,
      },
      get: {
        name: 'internalGetTemplateDescriptor',
        file: 'communicator',
        hasBody: false,
      },
      create: {
        name: 'internalCreateTemplateDescriptor',
        file: 'communicator',
        hasBody: true,
      },
      update: {
        name: 'internalUpdateTemplateDescriptor',
        file: 'communicator',
        hasBody: true,
      },
      delete: {
        name: 'internalDeleteTemplateDescriptor',
        file: 'communicator',
        hasBody: false,
      },
      actions: [
        {
          name: 'internalListTemplateVersionsByDescriptor',
          file: 'communicator',
          hasBody: false,
        },
        {
          name: 'bulkUpdateTemplateDescriptors',
          file: 'communicator',
          hasBody: true,
        },
        {
          name: 'listTemplateDescriptors',
          file: 'communicator',
          hasBody: false,
        },
        {
          name: 'getTemplateDescriptor',
          file: 'communicator',
          hasBody: false,
        },
        {
          name: 'createTemplateDescriptor',
          file: 'communicator',
          hasBody: true,
        },
        {
          name: 'updateTemplateDescriptor',
          file: 'communicator',
          hasBody: true,
        },
        {
          name: 'deleteTemplateDescriptor',
          file: 'communicator',
          hasBody: false,
        },
        {
          name: 'listTemplateVersionsByDescriptor',
          file: 'communicator',
          hasBody: false,
        },
      ],
    },
    formSchemas: {
      response: 'communicatorTemplatedescriptorsResponse',
      request: 'communicatorTemplatedescriptorsRequest',
    },
  },
  communicatorTemplates: {
    key: 'communicatorTemplates',
    path: '/companies/{companyId}/communicator/templates',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Template',
      plural: 'Templates',
    },
    idParam: 'templateVersionId',
    operations: {
      list: {
        name: 'internalListTemplateVersions',
        file: 'communicator',
        hasBody: false,
      },
      get: {
        name: 'internalGetTemplateVersion',
        file: 'communicator',
        hasBody: false,
      },
      create: {
        name: 'internalCreateTemplateVersion',
        file: 'communicator',
        hasBody: true,
      },
      update: {
        name: 'internalUpdateTemplateVersion',
        file: 'communicator',
        hasBody: true,
      },
      delete: {
        name: 'internalDeleteTemplateVersion',
        file: 'communicator',
        hasBody: false,
      },
      actions: [
        {
          name: 'internalActivateTemplateVersion',
          file: 'communicator',
          hasBody: false,
        },
        {
          name: 'internalExportTemplates',
          file: 'communicator',
          hasBody: false,
        },
        {
          name: 'internalImportTemplates',
          file: 'communicator',
          hasBody: true,
        },
        {
          name: 'internalConditionalImportTemplates',
          file: 'communicator',
          hasBody: true,
        },
        {
          name: 'listTemplateVersions',
          file: 'communicator',
          hasBody: false,
        },
        {
          name: 'getTemplateVersion',
          file: 'communicator',
          hasBody: false,
        },
        {
          name: 'createTemplateVersion',
          file: 'communicator',
          hasBody: true,
        },
        {
          name: 'updateTemplateVersion',
          file: 'communicator',
          hasBody: true,
        },
        {
          name: 'deleteTemplateVersion',
          file: 'communicator',
          hasBody: false,
        },
        {
          name: 'activateTemplateVersion',
          file: 'communicator',
          hasBody: false,
        },
        {
          name: 'previewTemplateVersion',
          file: 'communicator',
          hasBody: true,
        },
        {
          name: 'renderTemplateVersion',
          file: 'communicator',
          hasBody: true,
        },
        {
          name: 'getTemplateVars',
          file: 'communicator',
          hasBody: false,
        },
        {
          name: 'exportTemplates',
          file: 'communicator',
          hasBody: false,
        },
        {
          name: 'importTemplates',
          file: 'communicator',
          hasBody: true,
        },
      ],
    },
  },
  companies: {
    key: 'companies',
    path: '/companies',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Company',
      plural: 'Companies',
    },
    idParam: 'companyId',
    operations: {
      list: {
        name: 'companyGetAll',
        file: 'company',
        hasBody: false,
      },
      get: {
        name: 'companyGet',
        file: 'company',
        hasBody: false,
      },
      create: {
        name: 'createCompany',
        file: 'company',
        hasBody: true,
      },
      update: {
        name: 'updateCompany',
        file: 'company',
        hasBody: true,
      },
      actions: [
        {
          name: 'generateMetro2Files',
          file: 'credit-agencies',
          hasBody: true,
        },
        {
          name: 'internalDeferRemainingLocBalances',
          file: 'expected-payments',
          hasBody: true,
        },
        {
          name: 'internalCreateStatementDocument',
          file: 'statements',
          hasBody: false,
        },
        {
          name: 'transactionsCancelScheduledInternal',
          file: 'transactions-internal',
          hasBody: false,
        },
      ],
    },
    formSchemas: {
      response: 'companiesResponse',
      request: 'companiesRequest',
    },
  },
  company_3rdpartyPlaidCredentials: {
    key: 'company_3rdpartyPlaidCredentials',
    path: '/companies/{companyId}/3rdparty/plaid/credentials',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Credential',
      plural: 'Credentials',
    },
    operations: {
      create: {
        name: 'updatePlaidCredentials',
        file: 'company',
        hasBody: true,
      },
    },
    formSchemas: {
      request: 'company_3rdpartyPlaidCredentialsRequest',
    },
  },
  companyInteractionCallTranscriptSummaries: {
    key: 'companyInteractionCallTranscriptSummaries',
    path: '/companies/{companyId}/interactions/{interactionId}/call-transcripts/summaries',
    scope: 'company',
    pathParams: ['companyId', 'interactionId'],
    label: {
      singular: 'Summary',
      plural: 'Summaries',
    },
    operations: {
      list: {
        name: 'internalUnboundInteractionCallSummaryResultsGetByInteraction',
        file: 'interactions',
        hasBody: false,
      },
      actions: [
        {
          name: 'unboundInteractionCallSummaryResultsGetByInteraction',
          file: 'interactions',
          hasBody: false,
        },
      ],
    },
    formSchemas: {
      response: 'companyInteractionCallTranscriptSummariesResponse',
    },
  },
  companyPersonCases: {
    key: 'companyPersonCases',
    path: '/companies/{companyId}/people/{personId}/cases',
    scope: 'person',
    pathParams: ['companyId', 'personId'],
    label: {
      singular: 'Case',
      plural: 'Cases',
    },
    idParam: 'caseId',
    operations: {
      list: {
        name: 'internalListCasesByBorrower',
        file: 'cases',
        hasBody: false,
      },
      get: {
        name: 'internalGetCaseById',
        file: 'cases',
        hasBody: false,
      },
      create: {
        name: 'internalCreateCase',
        file: 'cases',
        hasBody: true,
      },
      update: {
        name: 'internalUpdateCase',
        file: 'cases',
        hasBody: true,
      },
      delete: {
        name: 'internalRemoveCaseAssociation',
        file: 'cases',
        hasBody: false,
      },
      actions: [
        {
          name: 'internalSnoozeCase',
          file: 'api-internal',
          hasBody: true,
        },
        {
          name: 'internalAddCaseAssociation',
          file: 'cases',
          hasBody: true,
        },
        {
          name: 'getCaseWorkflow',
          file: 'workflows',
          hasBody: false,
        },
        {
          name: 'listCasesByBorrower',
          file: 'cases',
          hasBody: false,
        },
        {
          name: 'getCaseById',
          file: 'cases',
          hasBody: false,
        },
        {
          name: 'createCase',
          file: 'cases',
          hasBody: true,
        },
        {
          name: 'updateCase',
          file: 'cases',
          hasBody: true,
        },
        {
          name: 'removeCaseAssociation',
          file: 'cases',
          hasBody: false,
        },
        {
          name: 'snoozeCase',
          file: 'api-public',
          hasBody: true,
        },
        {
          name: 'addCaseAssociation',
          file: 'cases',
          hasBody: true,
        },
        {
          name: 'viewCase',
          file: 'cases',
          hasBody: false,
        },
        {
          name: 'createTaskFromNote',
          file: 'cases',
          hasBody: true,
        },
      ],
    },
  },
  companyPersonContacts: {
    key: 'companyPersonContacts',
    path: '/companies/{companyId}/people/{personId}/contacts',
    scope: 'person',
    pathParams: ['companyId', 'personId'],
    label: {
      singular: 'Contact',
      plural: 'Contacts',
    },
    idParam: 'contactId',
    operations: {
      list: {
        name: 'internalListContactsForBorrower',
        file: 'contacts',
        hasBody: false,
      },
      get: {
        name: 'internalGetContactForBorrower',
        file: 'contacts',
        hasBody: false,
      },
      create: {
        name: 'internalCreateContactForBorrower',
        file: 'contacts',
        hasBody: true,
      },
      update: {
        name: 'internalUpdateContactForBorrower',
        file: 'contacts',
        hasBody: true,
      },
      delete: {
        name: 'internalDeleteContact',
        file: 'contacts',
        hasBody: false,
      },
      actions: [
        {
          name: 'internalCloneContact',
          file: 'contacts',
          hasBody: true,
        },
        {
          name: 'listContactsForBorrower',
          file: 'contacts',
          hasBody: false,
        },
        {
          name: 'getContactForBorrower',
          file: 'contacts',
          hasBody: false,
        },
        {
          name: 'createContactForBorrower',
          file: 'contacts',
          hasBody: true,
        },
        {
          name: 'updateContactForBorrower',
          file: 'contacts',
          hasBody: true,
        },
        {
          name: 'deleteContact',
          file: 'contacts',
          hasBody: false,
        },
        {
          name: 'cloneContact',
          file: 'contacts',
          hasBody: true,
        },
      ],
    },
    formSchemas: {
      response: 'companyPersonContactsResponse',
      request: 'companyPersonContactsRequest',
    },
  },
  companyPersonLoanDraws: {
    key: 'companyPersonLoanDraws',
    path: '/companies/{companyId}/people/{personId}/loans/{loanId}/draws',
    scope: 'loan',
    pathParams: ['companyId', 'personId', 'loanId'],
    label: {
      singular: 'Draw',
      plural: 'Draws',
    },
    idParam: 'drawId',
    operations: {
      list: {
        name: 'internalLoanDrawsGet',
        file: 'api-internal',
        hasBody: false,
      },
      get: {
        name: 'loanDrawGet',
        file: 'api-public',
        hasBody: false,
      },
      create: {
        name: 'internalLoanDrawsPost',
        file: 'api-internal',
        hasBody: true,
      },
      update: {
        name: 'drawUpdate',
        file: 'api-public',
        hasBody: true,
      },
      actions: [
        {
          name: 'internalDrawActivate',
          file: 'api-internal',
          hasBody: false,
        },
        {
          name: 'internalDrawChargeVariableDrawFee',
          file: 'api-internal',
          hasBody: false,
        },
        {
          name: 'refreshAmortizedDraw',
          file: 'api-internal',
          hasBody: true,
        },
        {
          name: 'internalDrawPurchasesGet',
          file: 'api-internal',
          hasBody: false,
        },
        {
          name: 'loanDrawsGet',
          file: 'api-public',
          hasBody: false,
        },
        {
          name: 'loanDrawsPost',
          file: 'api-public',
          hasBody: true,
        },
        {
          name: 'drawDynamicFeesAtOriginationUpdate',
          file: 'api-public',
          hasBody: true,
        },
        {
          name: 'drawClose',
          file: 'api-public',
          hasBody: true,
        },
        {
          name: 'drawReopen',
          file: 'api-public',
          hasBody: true,
        },
        {
          name: 'drawCancel',
          file: 'api-public',
          hasBody: true,
        },
        {
          name: 'drawMinPaymentCalculationPost',
          file: 'api-public',
          hasBody: true,
        },
        {
          name: 'drawGetCreditLimit',
          file: 'api-public',
          hasBody: false,
        },
        {
          name: 'drawUpdateCreditLimit',
          file: 'api-public',
          hasBody: true,
        },
        {
          name: 'drawRatesGet',
          file: 'api-public',
          hasBody: false,
        },
        {
          name: 'drawEffectiveRatesGet',
          file: 'api-public',
          hasBody: false,
        },
        {
          name: 'drawObligationsGetAll',
          file: 'api-public',
          hasBody: false,
        },
        {
          name: 'drawActivate',
          file: 'api-public',
          hasBody: false,
        },
        {
          name: 'loanDrawAmortize',
          file: 'api-public',
          hasBody: true,
        },
        {
          name: 'drawPurchasesGet',
          file: 'api-public',
          hasBody: false,
        },
        {
          name: 'drawPurchasesTimelineGet',
          file: 'api-public',
          hasBody: false,
        },
        {
          name: 'drawBalancesGet',
          file: 'api-public',
          hasBody: false,
        },
        {
          name: 'drawFutureBalancesGet',
          file: 'api-public',
          hasBody: false,
        },
        {
          name: 'drawExpectedPaymentsGet',
          file: 'expected-payments',
          hasBody: false,
        },
        {
          name: 'drawRateCapsGet',
          file: 'rate-caps',
          hasBody: false,
        },
      ],
    },
    formSchemas: {
      response: 'companyPersonLoanDrawsResponse',
      request: 'companyPersonLoanDrawsRequest',
    },
  },
  companyPersonLoanEvents: {
    key: 'companyPersonLoanEvents',
    path: '/companies/{companyId}/people/{personId}/loans/{loanId}/events',
    scope: 'loan',
    pathParams: ['companyId', 'personId', 'loanId'],
    label: {
      singular: 'Event',
      plural: 'Events',
    },
    idParam: 'eventId',
    operations: {
      update: {
        name: 'internalUpdateEvent',
        file: 'api-internal',
        hasBody: true,
      },
    },
    formSchemas: {
      request: 'companyPersonLoanEventsRequest',
    },
  },
  companyPersonLoanInvestors: {
    key: 'companyPersonLoanInvestors',
    path: '/companies/{companyId}/people/{personId}/loans/{loanId}/investors',
    scope: 'loan',
    pathParams: ['companyId', 'personId', 'loanId'],
    label: {
      singular: 'Investor',
      plural: 'Investors',
    },
    operations: {
      list: {
        name: 'internalLoanInvestorsGetAll',
        file: 'api-internal',
        hasBody: false,
      },
      update: {
        name: 'loanInvestorsUpdate',
        file: 'api-public',
        hasBody: true,
      },
      actions: [
        {
          name: 'loanInvestorsGetAll',
          file: 'api-public',
          hasBody: false,
        },
      ],
    },
    formSchemas: {
      response: 'companyPersonLoanInvestorsResponse',
      request: 'companyPersonLoanInvestorsRequest',
    },
  },
  companyPersonLoanObligations: {
    key: 'companyPersonLoanObligations',
    path: '/companies/{companyId}/people/{personId}/loans/{loanId}/obligations',
    scope: 'loan',
    pathParams: ['companyId', 'personId', 'loanId'],
    label: {
      singular: 'Obligation',
      plural: 'Obligations',
    },
    idParam: 'obligationId',
    operations: {
      list: {
        name: 'internalObligationsGetAll',
        file: 'api-internal',
        hasBody: false,
      },
      get: {
        name: 'obligationGetById',
        file: 'api-public',
        hasBody: false,
      },
      create: {
        name: 'internalObligationCreate',
        file: 'api-internal',
        hasBody: true,
      },
      update: {
        name: 'obligationUpdate',
        file: 'api-public',
        hasBody: true,
      },
      actions: [
        {
          name: 'internalObligationsRefresh',
          file: 'api-internal',
          hasBody: false,
        },
        {
          name: 'obligationsGetAll',
          file: 'api-public',
          hasBody: false,
        },
        {
          name: 'obligationCreate',
          file: 'api-public',
          hasBody: true,
        },
        {
          name: 'obligationsRefresh',
          file: 'api-internal',
          hasBody: false,
        },
      ],
    },
    formSchemas: {
      response: 'companyPersonLoanObligationsResponse',
      request: 'companyPersonLoanObligationsRequest',
    },
  },
  companyPersonLoans: {
    key: 'companyPersonLoans',
    path: '/companies/{companyId}/people/{personId}/loans',
    scope: 'person',
    pathParams: ['companyId', 'personId'],
    label: {
      singular: 'Loan',
      plural: 'Loans',
    },
    idParam: 'loanId',
    operations: {
      list: {
        name: 'internalLoansGet',
        file: 'api-internal',
        hasBody: false,
      },
      get: {
        name: 'internalLoanGet',
        file: 'api-internal',
        hasBody: false,
      },
      create: {
        name: 'internalLoansAdd',
        file: 'api-internal',
        hasBody: true,
      },
      update: {
        name: 'internalLoanUpdate',
        file: 'api-internal',
        hasBody: true,
      },
      actions: [
        {
          name: 'internalSyncPayoffStatus',
          file: 'api-internal',
          hasBody: false,
        },
        {
          name: 'loggingDebugger',
          file: 'api-internal',
          hasBody: true,
        },
        {
          name: 'internalLoanChargeOff',
          file: 'api-internal',
          hasBody: true,
        },
        {
          name: 'internalLoanDueDateDefer',
          file: 'api-internal',
          hasBody: true,
        },
        {
          name: 'internalLoanScheduleDefer',
          file: 'api-internal',
          hasBody: true,
        },
        {
          name: 'internalLoanAccelerate',
          file: 'api-internal',
          hasBody: true,
        },
        {
          name: 'internalLoanRefresh',
          file: 'api-internal',
          hasBody: false,
        },
        {
          name: 'internalLoanLateFeeCharge',
          file: 'api-internal',
          hasBody: false,
        },
        {
          name: 'internalLoanServiceFeeCharge',
          file: 'api-internal',
          hasBody: false,
        },
        {
          name: 'internalLoanNsfFeesCharge',
          file: 'api-internal',
          hasBody: true,
        },
        {
          name: 'internalFeesCancel',
          file: 'api-internal',
          hasBody: true,
        },
        {
          name: 'internalLoanPayoff',
          file: 'api-internal',
          hasBody: false,
        },
        {
          name: 'internalLoanPayoffReverse',
          file: 'api-internal',
          hasBody: false,
        },
        {
          name: 'internalFeeAdjustForLoc',
          file: 'api-internal',
          hasBody: true,
        },
        {
          name: 'internalFinalizeMinPaymentsForLoc',
          file: 'api-internal',
          hasBody: true,
        },
        {
          name: 'revokeOrReinstateGrace',
          file: 'api-internal',
          hasBody: true,
        },
        {
          name: 'internalComputeBalancesForGrace',
          file: 'api-internal',
          hasBody: false,
        },
        {
          name: 'internalLoanRefundsV2Post',
          file: 'api-internal',
          hasBody: true,
        },
        {
          name: 'internalLoanActivate',
          file: 'api-internal',
          hasBody: true,
        },
        {
          name: 'internalCloseLocIfInactive',
          file: 'api-internal',
          hasBody: false,
        },
        {
          name: 'internalClearMinPayments',
          file: 'api-internal',
          hasBody: false,
        },
        {
          name: 'internalCreditReportingStatusDelete',
          file: 'credit-agencies',
          hasBody: true,
        },
        {
          name: 'transactionsCreateVirtual',
          file: 'transactions-internal',
          hasBody: true,
        },
        {
          name: 'loansGet',
          file: 'api-public',
          hasBody: false,
        },
        {
          name: 'loanGet',
          file: 'api-public',
          hasBody: false,
        },
        {
          name: 'loansAdd',
          file: 'api-public',
          hasBody: true,
        },
        {
          name: 'loanUpdate',
          file: 'api-public',
          hasBody: true,
        },
        {
          name: 'loanPayoff',
          file: 'api-internal',
          hasBody: false,
        },
        {
          name: 'loanPayoffReverse',
          file: 'api-internal',
          hasBody: false,
        },
        {
          name: 'loanActivate',
          file: 'api-public',
          hasBody: true,
        },
        {
          name: 'loanReimburse',
          file: 'api-public',
          hasBody: true,
        },
        {
          name: 'loanRefundsV2Post',
          file: 'api-public',
          hasBody: true,
        },
        {
          name: 'loanCancel',
          file: 'api-public',
          hasBody: true,
        },
        {
          name: 'loanClose',
          file: 'api-public',
          hasBody: true,
        },
        {
          name: 'loanReopen',
          file: 'api-public',
          hasBody: true,
        },
        {
          name: 'feesCancel',
          file: 'api-public',
          hasBody: true,
        },
        {
          name: 'loanFreeze',
          file: 'api-public',
          hasBody: true,
        },
        {
          name: 'loanUnfreeze',
          file: 'api-public',
          hasBody: true,
        },
        {
          name: 'loanChargeOff',
          file: 'api-public',
          hasBody: true,
        },
        {
          name: 'loanChargeOffReverse',
          file: 'api-public',
          hasBody: true,
        },
        {
          name: 'loanAccelerate',
          file: 'api-public',
          hasBody: true,
        },
        {
          name: 'loanAccelerateReverse',
          file: 'api-public',
          hasBody: true,
        },
        {
          name: 'loanChangeTerms',
          file: 'api-public',
          hasBody: true,
        },
        {
          name: 'loanDueDateDefer',
          file: 'api-public',
          hasBody: true,
        },
        {
          name: 'loanScheduleDefer',
          file: 'api-public',
          hasBody: true,
        },
        {
          name: 'loanRefresh',
          file: 'api-public',
          hasBody: false,
        },
        {
          name: 'previewDrawAmortize',
          file: 'api-public',
          hasBody: true,
        },
        {
          name: 'internalPaidOffSideEffectsPost',
          file: 'borrowers',
          hasBody: true,
        },
        {
          name: 'loanMigrate',
          file: 'loc-migration',
          hasBody: false,
        },
        {
          name: 'internalCreateBackdatedPromiseToPayPlan',
          file: 'promise-to-pay',
          hasBody: true,
        },
      ],
    },
  },
  companyTransactions: {
    key: 'companyTransactions',
    path: '/companies/{companyId}/transactions',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Transaction',
      plural: 'Transactions',
    },
    operations: {
      list: {
        name: 'getReconciliationTransactionsByCompany',
        file: 'transactions-internal',
        hasBody: false,
      },
      create: {
        name: 'createReconciliation',
        file: 'transactions-internal',
        hasBody: true,
      },
      actions: [
        {
          name: 'transactionsGetInternal',
          file: 'transactions-internal',
          hasBody: false,
        },
        {
          name: 'transactionsUpdateInternal',
          file: 'transactions-internal',
          hasBody: true,
        },
        {
          name: 'transactionsCreateRefundServiceCreditInternal',
          file: 'transactions-internal',
          hasBody: true,
        },
        {
          name: 'transactionsCreateRoundingServiceCreditInternal',
          file: 'transactions-internal',
          hasBody: true,
        },
        {
          name: 'internalTransactionsGetLoanIds',
          file: 'transactions-internal',
          hasBody: true,
        },
      ],
    },
    formSchemas: {
      response: 'companyTransactionsResponse',
      request: 'companyTransactionsRequest',
    },
  },
  config: {
    key: 'config',
    path: '/companies/{companyId}/config',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Config',
      plural: 'Configs',
    },
    operations: {
      get: {
        name: 'getCompanyConfig',
        file: 'company',
        hasBody: false,
      },
      update: {
        name: 'setCompanyConfig',
        file: 'company',
        hasBody: true,
      },
    },
    formSchemas: {
      response: 'company',
    },
  },
  consents: {
    key: 'consents',
    path: '/companies/{companyId}/people/{personId}/consents',
    scope: 'person',
    pathParams: ['companyId', 'personId'],
    label: {
      singular: 'Consent',
      plural: 'Consents',
    },
    operations: {
      list: {
        name: 'internalConsentGet',
        file: 'api-internal',
        hasBody: false,
      },
      update: {
        name: 'internalConsentUpdate',
        file: 'api-internal',
        hasBody: true,
      },
      actions: [
        {
          name: 'consentGet',
          file: 'api-public',
          hasBody: false,
        },
        {
          name: 'consentUpdate',
          file: 'api-public',
          hasBody: true,
        },
      ],
    },
    formSchemas: {
      response: 'consentsResponse',
    },
  },
  contacts: {
    key: 'contacts',
    path: '/companies/{companyId}/contacts',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Contact',
      plural: 'Contacts',
    },
    operations: {
      list: {
        name: 'internalListContacts',
        file: 'contacts',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'contactsResponse',
    },
  },
  credentialPlaid: {
    key: 'credentialPlaid',
    path: '/companies/{companyId}/credentials/plaid',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Plaid',
      plural: 'Plaids',
    },
    operations: {
      create: {
        name: 'legacyUpdatePlaidCredentials',
        file: 'company',
        hasBody: true,
      },
    },
    formSchemas: {
      request: 'credentialPlaidRequest',
    },
  },
  creditAgencies: {
    key: 'creditAgencies',
    path: '/companies/{companyId}/credit-agencies',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Credit Agency',
      plural: 'Credit Agencies',
    },
    idParam: 'creditAgencyId',
    operations: {
      list: {
        name: 'creditAgenciesList',
        file: 'credit-agencies',
        hasBody: false,
      },
      get: {
        name: 'creditAgencyGet',
        file: 'credit-agencies',
        hasBody: false,
      },
      create: {
        name: 'creditAgencyCreate',
        file: 'credit-agencies',
        hasBody: true,
      },
      update: {
        name: 'creditAgencyUpdate',
        file: 'credit-agencies',
        hasBody: true,
      },
      actions: [
        {
          name: 'creditAgencyRegenerateSshKeys',
          file: 'credit-agencies',
          hasBody: false,
        },
      ],
    },
    formSchemas: {
      response: 'creditAgenciesResponse',
      request: 'creditAgenciesRequest',
      updateRequest: 'creditAgenciesUpdateRequest',
    },
  },
  creditLimit: {
    key: 'creditLimit',
    path: '/people/{personId}/loans/{loanId}/credit-limit',
    scope: 'loan',
    pathParams: ['personId', 'loanId'],
    label: {
      singular: 'Credit Limit',
      plural: 'Credit Limits',
    },
    operations: {
      list: {
        name: 'loanGetCreditLimit',
        file: 'api-public',
        hasBody: false,
      },
      create: {
        name: 'loanUpdateCreditLimit',
        file: 'api-public',
        hasBody: true,
      },
    },
    formSchemas: {
      response: 'creditLimitResponse',
      request: 'creditLimitRequest',
    },
  },
  creditReporting: {
    key: 'creditReporting',
    path: '/people/{personId}/loans/{loanId}/credit-reporting',
    scope: 'loan',
    pathParams: ['personId', 'loanId'],
    label: {
      singular: 'Credit Reporting',
      plural: 'Credit Reportings',
    },
    operations: {
      list: {
        name: 'creditReportingStatusesList',
        file: 'credit-agencies',
        hasBody: false,
      },
      create: {
        name: 'creditReportingStatusCreate',
        file: 'credit-agencies',
        hasBody: true,
      },
      update: {
        name: 'creditReportingFieldsUpdate',
        file: 'credit-agencies',
        hasBody: true,
      },
      actions: [
        {
          name: 'creditReportingStatusDelete',
          file: 'credit-agencies',
          hasBody: true,
        },
        {
          name: 'getMetro2Data',
          file: 'credit-agencies',
          hasBody: false,
        },
      ],
    },
    formSchemas: {
      response: 'creditReportingResponse',
      request: 'creditReportingRequest',
    },
  },
  creditReportingCreateFileRecord: {
    key: 'creditReportingCreateFileRecord',
    path: '/credit-reporting/create-file-record',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Create File Record',
      plural: 'Create File Records',
    },
    operations: {
      create: {
        name: 'fileCreationRecordCreate',
        file: 'credit-agencies',
        hasBody: true,
      },
    },
    formSchemas: {
      request: 'creditReportingCreateFileRecordRequest',
    },
    companyAmbiguous: true,
  },
  creditReportingReportedLoans: {
    key: 'creditReportingReportedLoans',
    path: '/companies/{companyId}/credit-reporting/reported-loans',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Reported Loan',
      plural: 'Reported Loans',
    },
    operations: {
      list: {
        name: 'reportedLoans',
        file: 'credit-agencies',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'creditReportingReportedLoansResponse',
    },
  },
  creditreportings: {
    key: 'creditreportings',
    path: '/people/{personId}/loans/{loanId}/creditreportings',
    scope: 'loan',
    pathParams: ['personId', 'loanId'],
    label: {
      singular: 'Creditreporting',
      plural: 'Creditreportings',
    },
    idParam: 'creditReportingId',
    operations: {
      list: {
        name: 'loanCreditreportingsGet',
        file: 'api-public',
        hasBody: false,
      },
      get: {
        name: 'loanCreditreportingGet',
        file: 'api-public',
        hasBody: false,
      },
      create: {
        name: 'loanCreditreportingsAdd',
        file: 'api-public',
        hasBody: true,
      },
      update: {
        name: 'loanCreditreportingUpdate',
        file: 'api-public',
        hasBody: true,
      },
      delete: {
        name: 'loanCreditreportingDelete',
        file: 'api-public',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'creditreportingsResponse',
      request: 'creditreportingsRequest',
    },
  },
  customPaymentPlanRefresh: {
    key: 'customPaymentPlanRefresh',
    path: '/companies/{companyId}/people/{personId}/loans/{loanId}/custom-payment-plans/refresh',
    scope: 'loan',
    pathParams: ['companyId', 'personId', 'loanId'],
    label: {
      singular: 'Refresh',
      plural: 'Refreshes',
    },
    operations: {
      create: {
        name: 'internalLoanCustomPaymentPlanRefresh',
        file: 'api-internal',
        hasBody: false,
      },
    },
  },
  customPaymentPlans: {
    key: 'customPaymentPlans',
    path: '/people/{personId}/loans/{loanId}/custom-payment-plans',
    scope: 'loan',
    pathParams: ['personId', 'loanId'],
    label: {
      singular: 'Custom Payment Plan',
      plural: 'Custom Payment Plans',
    },
    idParam: 'paymentPlanId',
    operations: {
      list: {
        name: 'loanCustomPaymentPlanGet',
        file: 'api-public',
        hasBody: false,
      },
      get: {
        name: 'loanCustomPaymentPlanGetById',
        file: 'api-public',
        hasBody: false,
      },
      create: {
        name: 'loanCustomPaymentPlanCreate',
        file: 'api-public',
        hasBody: true,
      },
      actions: [
        {
          name: 'loanCustomPaymentPlanCancel',
          file: 'api-public',
          hasBody: true,
        },
      ],
    },
    formSchemas: {
      response: 'customPaymentPlansResponse',
      request: 'customPaymentPlansRequest',
    },
  },
  disasters: {
    key: 'disasters',
    path: '/disasters',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Disaster',
      plural: 'Disasters',
    },
    operations: {
      list: {
        name: 'getAllDisasters',
        file: 'api-internal',
        hasBody: false,
      },
      create: {
        name: 'createDisaster',
        file: 'api-internal',
        hasBody: true,
      },
      actions: [
        {
          name: 'getDisasterImpactedAreasCsv',
          file: 'api-internal',
          hasBody: false,
        },
        {
          name: 'findNewUpdatedDisasters',
          file: 'api-internal',
          hasBody: true,
        },
      ],
    },
    formSchemas: {
      response: 'disastersResponse',
      request: 'disastersRequest',
    },
    companyAmbiguous: true,
  },
  disputes: {
    key: 'disputes',
    path: '/people/{personId}/loans/{loanId}/disputes',
    scope: 'loan',
    pathParams: ['personId', 'loanId'],
    label: {
      singular: 'Dispute',
      plural: 'Disputes',
    },
    operations: {
      list: {
        name: 'purchaseDisputesListForLoc',
        file: 'purchase-disputes',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'disputesResponse',
    },
  },
  documents: {
    key: 'documents',
    path: '/companies/{companyId}/documents',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Document',
      plural: 'Documents',
    },
    idParam: 'documentDescriptorId',
    operations: {
      list: {
        name: 'listCompanyDocuments',
        file: 'docustore',
        hasBody: false,
      },
      get: {
        name: 'getCompanyDocument',
        file: 'docustore',
        hasBody: false,
      },
      create: {
        name: 'createCompanyDocument',
        file: 'docustore',
        hasBody: true,
      },
      update: {
        name: 'updateCompanyDocument',
        file: 'docustore',
        hasBody: true,
      },
      actions: [
        {
          name: 'downloadCompanyDocumentContent',
          file: 'docustore',
          hasBody: false,
        },
        {
          name: 'uploadCompanyDocumentContent',
          file: 'docustore',
          hasBody: true,
        },
        {
          name: 'convertCompanyDocument',
          file: 'docustore',
          hasBody: false,
        },
        {
          name: 'reconvertCompanyDocument',
          file: 'docustore',
          hasBody: false,
        },
        {
          name: 'signCompanyPdfDocument',
          file: 'docustore',
          hasBody: false,
        },
      ],
    },
    formSchemas: {
      response: 'documentsResponse',
      request: 'documentsRequest',
    },
  },
  documentUploadDocuments: {
    key: 'documentUploadDocuments',
    path: '/document-uploads/{documentUploadLinkKey}/documents',
    scope: 'global',
    pathParams: ['documentUploadLinkKey'],
    label: {
      singular: 'Document',
      plural: 'Documents',
    },
    operations: {
      create: {
        name: 'createDocumentViaLink',
        file: 'docustore',
        hasBody: true,
      },
      actions: [
        {
          name: 'uploadDocumentContentViaLink',
          file: 'docustore',
          hasBody: true,
        },
      ],
    },
    formSchemas: {
      request: 'documentUploadDocumentsRequest',
    },
  },
  documentUploadLinks: {
    key: 'documentUploadLinks',
    path: '/people/{personId}/document-upload-links',
    scope: 'person',
    pathParams: ['personId'],
    label: {
      singular: 'Document Upload Link',
      plural: 'Document Upload Links',
    },
    idParam: 'documentUploadLinkId',
    operations: {
      list: {
        name: 'getDocumentUploadLinks',
        file: 'docustore',
        hasBody: false,
      },
      get: {
        name: 'getDocumentUploadLink',
        file: 'docustore',
        hasBody: false,
      },
      create: {
        name: 'createDocumentUploadLink',
        file: 'docustore',
        hasBody: true,
      },
    },
    formSchemas: {
      response: 'documentUploadLinksResponse',
      request: 'documentUploadLinksRequest',
    },
  },
  doNotInteracts: {
    key: 'doNotInteracts',
    path: '/people/{personId}/do-not-interacts',
    scope: 'person',
    pathParams: ['personId'],
    label: {
      singular: 'Do Not Interact',
      plural: 'Do Not Interacts',
    },
    operations: {
      list: {
        name: 'peopleDoNotInteractGetAll',
        file: 'api-public',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'doNotInteractsResponse',
    },
  },
  doNotInteractTypes: {
    key: 'doNotInteractTypes',
    path: '/do-not-interact-types',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Do Not Interact Type',
      plural: 'Do Not Interact Types',
    },
    idParam: 'doNotInteractTypeId',
    operations: {
      list: {
        name: 'doNotInteractTypeGetAll',
        file: 'api-public',
        hasBody: false,
      },
      get: {
        name: 'doNotInteractTypeGetById',
        file: 'api-public',
        hasBody: false,
      },
      create: {
        name: 'doNotInteractTypeCreate',
        file: 'api-public',
        hasBody: true,
      },
      update: {
        name: 'doNotInteractTypeUpdate',
        file: 'api-public',
        hasBody: true,
      },
    },
    formSchemas: {
      response: 'doNotInteractTypesResponse',
      request: 'doNotInteractTypesRequest',
    },
    companyAmbiguous: true,
  },
  drawDisputes: {
    key: 'drawDisputes',
    path: '/people/{personId}/loans/{loanId}/draws/{drawId}/disputes',
    scope: 'loan',
    pathParams: ['personId', 'loanId', 'drawId'],
    label: {
      singular: 'Dispute',
      plural: 'Disputes',
    },
    operations: {
      list: {
        name: 'purchaseDisputesListForDraw',
        file: 'purchase-disputes',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'drawDisputesResponse',
    },
  },
  drawExpectedPaymentDeferRemainingBalances: {
    key: 'drawExpectedPaymentDeferRemainingBalances',
    path: '/people/{personId}/loans/{loanId}/draws/{drawId}/expected-payments/defer-remaining-balances',
    scope: 'loan',
    pathParams: ['personId', 'loanId', 'drawId'],
    label: {
      singular: 'Defer Remaining Balance',
      plural: 'Defer Remaining Balances',
    },
    operations: {
      create: {
        name: 'deferRemainingDrawBalances',
        file: 'expected-payments',
        hasBody: true,
      },
    },
    formSchemas: {
      request: 'drawExpectedPaymentDeferRemainingBalancesRequest',
    },
  },
  drawFeeDraw: {
    key: 'drawFeeDraw',
    path: '/people/{personId}/loans/{loanId}/draws/{drawId}/fees/draw',
    scope: 'loan',
    pathParams: ['personId', 'loanId', 'drawId'],
    label: {
      singular: 'Draw',
      plural: 'Draws',
    },
    operations: {
      update: {
        name: 'updateDrawFee',
        file: 'api-public',
        hasBody: true,
      },
    },
    formSchemas: {
      request: 'drawFeeDrawRequest',
    },
  },
  drawMigrationPeriod: {
    key: 'drawMigrationPeriod',
    path: '/people/{personId}/loans/{loanId}/draws/{drawId}/migration/period',
    scope: 'loan',
    pathParams: ['personId', 'loanId', 'drawId'],
    label: {
      singular: 'Period',
      plural: 'Periods',
    },
    operations: {
      list: {
        name: 'migrationPeriodDrawGet',
        file: 'loc-migration',
        hasBody: false,
      },
      create: {
        name: 'migrationPeriodDrawCreate',
        file: 'loc-migration',
        hasBody: true,
      },
      update: {
        name: 'migrationPeriodDrawUpdate',
        file: 'loc-migration',
        hasBody: true,
      },
    },
    formSchemas: {
      response: 'drawMigrationPeriodResponse',
      request: 'drawMigrationPeriodRequest',
    },
  },
  drawObligations: {
    key: 'drawObligations',
    path: '/people/{personId}/loans/{loanId}/draws/{drawId}/obligations',
    scope: 'loan',
    pathParams: ['personId', 'loanId', 'drawId'],
    label: {
      singular: 'Obligation',
      plural: 'Obligations',
    },
    idParam: 'obligationId',
    operations: {
      get: {
        name: 'drawObligationGetById',
        file: 'api-public',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'drawObligationsResponse',
    },
  },
  drawPromoPrograms: {
    key: 'drawPromoPrograms',
    path: '/people/{personId}/loans/{loanId}/draws/{drawId}/promo-programs',
    scope: 'loan',
    pathParams: ['personId', 'loanId', 'drawId'],
    label: {
      singular: 'Promo Program',
      plural: 'Promo Programs',
    },
    idParam: 'promoProgramId',
    operations: {
      get: {
        name: 'promoProgramsDrawGet',
        file: 'promoprogram',
        hasBody: false,
      },
      create: {
        name: 'promoProgramsDrawAdd',
        file: 'promoprogram',
        hasBody: true,
      },
      update: {
        name: 'promoProgramsDrawUpdate',
        file: 'promoprogram',
        hasBody: true,
      },
      delete: {
        name: 'promoProgramsDrawDelete',
        file: 'promoprogram',
        hasBody: false,
      },
      actions: [
        {
          name: 'promoProgramsDrawActivate',
          file: 'promoprogram',
          hasBody: false,
        },
      ],
    },
    formSchemas: {
      response: 'drawPromoProgramsResponse',
      request: 'drawPromoProgramsRequest',
    },
  },
  drawPurchaseDisputes: {
    key: 'drawPurchaseDisputes',
    path: '/people/{personId}/loans/{loanId}/draws/{drawId}/purchases/{purchaseId}/disputes',
    scope: 'loan',
    pathParams: ['personId', 'loanId', 'drawId', 'purchaseId'],
    label: {
      singular: 'Dispute',
      plural: 'Disputes',
    },
    idParam: 'purchaseDisputeId',
    operations: {
      list: {
        name: 'purchaseDisputesListForPurchase',
        file: 'purchase-disputes',
        hasBody: false,
      },
      get: {
        name: 'purchaseDisputeGet',
        file: 'purchase-disputes',
        hasBody: false,
      },
      create: {
        name: 'purchaseDisputeCreate',
        file: 'purchase-disputes',
        hasBody: true,
      },
      update: {
        name: 'purchaseDisputeUpdate',
        file: 'purchase-disputes',
        hasBody: true,
      },
    },
    formSchemas: {
      response: 'drawPurchaseDisputesResponse',
      request: 'drawPurchaseDisputesRequest',
    },
  },
  drawPurchases: {
    key: 'drawPurchases',
    path: '/companies/{companyId}/people/{personId}/loans/{loanId}/draws/{drawId}/purchases',
    scope: 'loan',
    pathParams: ['companyId', 'personId', 'loanId', 'drawId'],
    label: {
      singular: 'Purchase',
      plural: 'Purchases',
    },
    idParam: 'purchaseId',
    operations: {
      get: {
        name: 'internalDrawPurchaseGetOne',
        file: 'api-internal',
        hasBody: false,
      },
      create: {
        name: 'internalDrawPurchasesCreate',
        file: 'api-internal',
        hasBody: true,
      },
      update: {
        name: 'internalDrawPurchaseUpdate',
        file: 'api-internal',
        hasBody: true,
      },
      actions: [
        {
          name: 'internalDrawPurchaseChargeFees',
          file: 'api-internal',
          hasBody: true,
        },
        {
          name: 'drawPurchaseGetOne',
          file: 'api-public',
          hasBody: false,
        },
        {
          name: 'drawPurchasesCreate',
          file: 'api-public',
          hasBody: true,
        },
        {
          name: 'drawPurchaseUpdate',
          file: 'api-public',
          hasBody: true,
        },
      ],
    },
    formSchemas: {
      response: 'drawPurchasesResponse',
      request: 'drawPurchasesRequest',
    },
  },
  drawRateCaps: {
    key: 'drawRateCaps',
    path: '/people/{personId}/loans/{loanId}/draws/{drawId}/rate-caps',
    scope: 'loan',
    pathParams: ['personId', 'loanId', 'drawId'],
    label: {
      singular: 'Rate Cap',
      plural: 'Rate Caps',
    },
    idParam: 'rateCapId',
    operations: {
      create: {
        name: 'drawRateCapAdd',
        file: 'rate-caps',
        hasBody: true,
      },
      update: {
        name: 'drawRateCapUpdate',
        file: 'rate-caps',
        hasBody: true,
      },
      delete: {
        name: 'drawRateCapDelete',
        file: 'rate-caps',
        hasBody: false,
      },
    },
    formSchemas: {
      request: 'drawRateCapsRequest',
    },
  },
  drawRates: {
    key: 'drawRates',
    path: '/people/{personId}/loans/{loanId}/draws/{drawId}/rates',
    scope: 'loan',
    pathParams: ['personId', 'loanId', 'drawId'],
    label: {
      singular: 'Rate',
      plural: 'Rates',
    },
    idParam: 'rateId',
    operations: {
      create: {
        name: 'drawRatesAdd',
        file: 'api-public',
        hasBody: true,
      },
      update: {
        name: 'drawRatesUpdate',
        file: 'api-public',
        hasBody: true,
      },
      delete: {
        name: 'drawRatesDelete',
        file: 'api-public',
        hasBody: false,
      },
    },
    formSchemas: {
      request: 'drawRatesRequest',
    },
  },
  draws: {
    key: 'draws',
    path: '/companies/{companyId}/loans/{loanId}/draws',
    scope: 'loan',
    pathParams: ['companyId', 'loanId'],
    label: {
      singular: 'Draw',
      plural: 'Draws',
    },
    operations: {
      list: {
        name: 'internalLoanDrawsGetWithoutBorrower',
        file: 'api-internal',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'drawsResponse',
    },
  },
  effectiveRates: {
    key: 'effectiveRates',
    path: '/people/{personId}/loans/{loanId}/effective-rates',
    scope: 'loan',
    pathParams: ['personId', 'loanId'],
    label: {
      singular: 'Effective Rate',
      plural: 'Effective Rates',
    },
    operations: {
      list: {
        name: 'loanEffectiveRatesGet',
        file: 'api-public',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'effectiveRatesResponse',
    },
  },
  employeeAssignedInvestors: {
    key: 'employeeAssignedInvestors',
    path: '/employees/{employeeId}/assigned-investors',
    scope: 'global',
    pathParams: ['employeeId'],
    label: {
      singular: 'Assigned Investor',
      plural: 'Assigned Investors',
    },
    idParam: 'investorId',
    operations: {
      update: {
        name: 'internalEmployeeAssignInvestor',
        file: 'employees',
        hasBody: false,
      },
      delete: {
        name: 'internalEmployeeUnassignInvestor',
        file: 'employees',
        hasBody: false,
      },
    },
  },
  employees: {
    key: 'employees',
    path: '/companies/{companyId}/employees',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Employee',
      plural: 'Employees',
    },
    idParam: 'employeeId',
    operations: {
      list: {
        name: 'internalEmployeesGet',
        file: 'employees',
        hasBody: false,
      },
      get: {
        name: 'internalEmployeeGetById',
        file: 'employees',
        hasBody: false,
      },
      create: {
        name: 'internalEmployeeCreate',
        file: 'employees',
        hasBody: true,
      },
      update: {
        name: 'internalEmployeeUpdate',
        file: 'employees',
        hasBody: true,
      },
      actions: [
        {
          name: 'internalSyncTwilioWorkerByEmployeeId',
          file: 'employees',
          hasBody: false,
        },
        {
          name: 'employeesGet',
          file: 'employees',
          hasBody: false,
        },
        {
          name: 'employeeGetById',
          file: 'employees',
          hasBody: false,
        },
        {
          name: 'employeeCreate',
          file: 'employees',
          hasBody: true,
        },
        {
          name: 'employeeUpdate',
          file: 'employees',
          hasBody: true,
        },
        {
          name: 'employeeEmailSignatureGet',
          file: 'employees',
          hasBody: false,
        },
        {
          name: 'employeeEmailSignatureSet',
          file: 'employees',
          hasBody: true,
        },
        {
          name: 'internalGetEmployeeAssignedInvestors',
          file: 'employees',
          hasBody: false,
        },
      ],
    },
    formSchemas: {
      response: 'employeesResponse',
      request: 'employeesRequest',
      updateRequest: 'employeesUpdateRequest',
    },
  },
  employeeTeams: {
    key: 'employeeTeams',
    path: '/companies/{companyId}/employees/{employeeId}/teams',
    scope: 'company',
    pathParams: ['companyId', 'employeeId'],
    label: {
      singular: 'Team',
      plural: 'Teams',
    },
    idParam: 'teamId',
    operations: {
      update: {
        name: 'internalEmployeeAddToTeam',
        file: 'employees',
        hasBody: false,
      },
      delete: {
        name: 'internalEmployeeRemoveFromTeam',
        file: 'employees',
        hasBody: false,
      },
      actions: [
        {
          name: 'employeeAddToTeam',
          file: 'employees',
          hasBody: false,
        },
        {
          name: 'employeeRemoveFromTeam',
          file: 'employees',
          hasBody: false,
        },
      ],
    },
  },
  events: {
    key: 'events',
    path: '/companies/{companyId}/events',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Event',
      plural: 'Events',
    },
    operations: {
      list: {
        name: 'internalGetEvents',
        file: 'api-internal',
        hasBody: false,
      },
      create: {
        name: 'internalCreateEvent',
        file: 'api-internal',
        hasBody: true,
      },
      actions: [
        {
          name: 'internalCreateEventsBulk',
          file: 'api-internal',
          hasBody: true,
        },
        {
          name: 'getEventsExternal',
          file: 'api-public',
          hasBody: false,
        },
        {
          name: 'createEvent',
          file: 'api-public',
          hasBody: true,
        },
        {
          name: 'createEventsBulk',
          file: 'api-public',
          hasBody: true,
        },
      ],
    },
    formSchemas: {
      response: 'eventsResponse',
    },
  },
  expandUrl: {
    key: 'expandUrl',
    path: '/expand-url',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Expand Url',
      plural: 'Expand Urls',
    },
    idParam: 'shortId',
    operations: {
      get: {
        name: 'expandUrl',
        file: 'api-internal',
        hasBody: false,
      },
    },
    companyAmbiguous: true,
  },
  expectedPaymentOverride: {
    key: 'expectedPaymentOverride',
    path: '/companies/{companyId}/people/{personId}/loans/{loanId}/expected-payments/override',
    scope: 'loan',
    pathParams: ['companyId', 'personId', 'loanId'],
    label: {
      singular: 'Override',
      plural: 'Overrides',
    },
    operations: {
      update: {
        name: 'internalLoanExpectedPaymentOverride',
        file: 'expected-payments',
        hasBody: true,
      },
    },
    formSchemas: {
      request: 'expectedPaymentOverrideRequest',
    },
  },
  expectedPayments: {
    key: 'expectedPayments',
    path: '/companies/{companyId}/people/{personId}/loans/{loanId}/expected-payments',
    scope: 'loan',
    pathParams: ['companyId', 'personId', 'loanId'],
    label: {
      singular: 'Expected Payment',
      plural: 'Expected Payments',
    },
    idParam: 'expectedPaymentId',
    operations: {
      list: {
        name: 'internalLoanExpectedPaymentsGet',
        file: 'expected-payments',
        hasBody: false,
      },
      get: {
        name: 'internalLoanExpectedPaymentsGetOne',
        file: 'expected-payments',
        hasBody: false,
      },
      create: {
        name: 'internalLoanChangeDueDatesSchedulePost',
        file: 'expected-payments',
        hasBody: true,
      },
      actions: [
        {
          name: 'internalLoanExpectedPaymentsRefresh',
          file: 'expected-payments',
          hasBody: false,
        },
        {
          name: 'internalLoanExpectedPaymentsOverLimit',
          file: 'expected-payments',
          hasBody: true,
        },
        {
          name: 'loanExpectedPaymentsGet',
          file: 'expected-payments',
          hasBody: false,
        },
        {
          name: 'loanChangeDueDatesSchedulePost',
          file: 'expected-payments',
          hasBody: true,
        },
        {
          name: 'deferRemainingLocBalances',
          file: 'expected-payments',
          hasBody: true,
        },
        {
          name: 'loanExpectedPaymentsRefresh',
          file: 'expected-payments',
          hasBody: false,
        },
      ],
    },
    formSchemas: {
      response: 'expectedPaymentsResponse',
      request: 'expectedPaymentsRequest',
    },
  },
  feeOrigination: {
    key: 'feeOrigination',
    path: '/people/{personId}/loans/{loanId}/fees/origination',
    scope: 'loan',
    pathParams: ['personId', 'loanId'],
    label: {
      singular: 'Origination',
      plural: 'Originations',
    },
    operations: {
      update: {
        name: 'updateOriginationFee',
        file: 'api-public',
        hasBody: true,
      },
    },
    formSchemas: {
      request: 'feeOriginationRequest',
    },
  },
  fees: {
    key: 'fees',
    path: '/companies/{companyId}/people/{personId}/loans/{loanId}/fees',
    scope: 'loan',
    pathParams: ['companyId', 'personId', 'loanId'],
    label: {
      singular: 'Fee',
      plural: 'Fees',
    },
    idParam: 'loanFeeId',
    operations: {
      list: {
        name: 'internalFeesGet',
        file: 'api-internal',
        hasBody: false,
      },
      get: {
        name: 'internalDynamicFeeGet',
        file: 'api-internal',
        hasBody: false,
      },
      create: {
        name: 'internalFeesPost',
        file: 'api-internal',
        hasBody: true,
      },
      update: {
        name: 'internalDynamicFeeUpdate',
        file: 'api-internal',
        hasBody: true,
      },
      actions: [
        {
          name: 'internalMarkFeeBooked',
          file: 'api-internal',
          hasBody: false,
        },
        {
          name: 'internalFeesCancelOne',
          file: 'api-internal',
          hasBody: true,
        },
        {
          name: 'feesGet',
          file: 'api-public',
          hasBody: false,
        },
        {
          name: 'feesPost',
          file: 'api-public',
          hasBody: true,
        },
        {
          name: 'dynamicFeeUpdate',
          file: 'api-public',
          hasBody: true,
        },
        {
          name: 'feesCancelOne',
          file: 'api-public',
          hasBody: true,
        },
      ],
    },
    formSchemas: {
      response: 'feesResponse',
      request: 'feesRequest',
    },
  },
  forecastInterest: {
    key: 'forecastInterest',
    path: '/companies/{companyId}/people/{personId}/loans/{loanId}/forecast-interest',
    scope: 'loan',
    pathParams: ['companyId', 'personId', 'loanId'],
    label: {
      singular: 'Forecast Interest',
      plural: 'Forecast Interests',
    },
    operations: {
      list: {
        name: 'internalForecastInterest',
        file: 'api-internal',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'forecastInterestResponse',
    },
  },
  frontendConfig: {
    key: 'frontendConfig',
    path: '/frontend-config',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Frontend Config',
      plural: 'Frontend Configs',
    },
    operations: {
      list: {
        name: 'getFrontendConfig',
        file: 'frontend',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'frontendConfigResponse',
    },
    companyAmbiguous: true,
  },
  futureBalances: {
    key: 'futureBalances',
    path: '/companies/{companyId}/people/{personId}/loans/{loanId}/future_balances',
    scope: 'loan',
    pathParams: ['companyId', 'personId', 'loanId'],
    label: {
      singular: 'Future Balance',
      plural: 'Future Balances',
    },
    operations: {
      list: {
        name: 'internalLoanFutureBalancesGet',
        file: 'api-internal',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'futureBalancesResponse',
    },
  },
  identities: {
    key: 'identities',
    path: '/companies/{companyId}/people/{personId}/identities',
    scope: 'person',
    pathParams: ['companyId', 'personId'],
    label: {
      singular: 'Identity',
      plural: 'Identities',
    },
    idParam: 'personIdentityId',
    operations: {
      list: {
        name: 'internalListIdentities',
        file: 'borrowers',
        hasBody: false,
      },
      get: {
        name: 'internalGetIdentity',
        file: 'borrowers',
        hasBody: false,
      },
      create: {
        name: 'internalCreateIdentity',
        file: 'borrowers',
        hasBody: true,
      },
      update: {
        name: 'internalUpdateIdentity',
        file: 'borrowers',
        hasBody: true,
      },
      delete: {
        name: 'internalDeleteIdentity',
        file: 'borrowers',
        hasBody: false,
      },
      actions: [
        {
          name: 'listIdentities',
          file: 'borrowers',
          hasBody: false,
        },
        {
          name: 'getIdentity',
          file: 'borrowers',
          hasBody: false,
        },
        {
          name: 'createIdentity',
          file: 'borrowers',
          hasBody: true,
        },
        {
          name: 'updateIdentity',
          file: 'borrowers',
          hasBody: true,
        },
        {
          name: 'deleteIdentity',
          file: 'borrowers',
          hasBody: false,
        },
      ],
    },
    formSchemas: {
      response: 'identitiesResponse',
      request: 'identitiesRequest',
    },
  },
  identity: {
    key: 'identity',
    path: '/companies/{companyId}/people/{personId}/identity',
    scope: 'person',
    pathParams: ['companyId', 'personId'],
    label: {
      singular: 'Identity',
      plural: 'Identities',
    },
    operations: {
      list: {
        name: 'internalGetPrimaryIdentity',
        file: 'borrowers',
        hasBody: false,
      },
      actions: [
        {
          name: 'getPrimaryIdentity',
          file: 'borrowers',
          hasBody: false,
        },
      ],
    },
    formSchemas: {
      response: 'identityResponse',
    },
  },
  indexDocs: {
    key: 'indexDocs',
    path: '/companies/{companyId}/people/{personId}/index-docs',
    scope: 'person',
    pathParams: ['companyId', 'personId'],
    label: {
      singular: 'Index Doc',
      plural: 'Index Docs',
    },
    operations: {
      list: {
        name: 'adminGetBorrowerIndex',
        file: 'borrowers',
        hasBody: false,
      },
      create: {
        name: 'adminBorrowerReindex',
        file: 'borrowers',
        hasBody: true,
      },
    },
    formSchemas: {
      request: 'indexDocsRequest',
    },
  },
  interactionCallTranscripts: {
    key: 'interactionCallTranscripts',
    path: '/companies/{companyId}/interactions/{interactionId}/call-transcripts',
    scope: 'company',
    pathParams: ['companyId', 'interactionId'],
    label: {
      singular: 'Call Transcript',
      plural: 'Call Transcripts',
    },
    idParam: 'aICallTranscriptionResultId',
    operations: {
      list: {
        name: 'internalUnboundInteractionCallTranscriptionResultsGetByInteraction',
        file: 'interactions',
        hasBody: false,
      },
      get: {
        name: 'internalUnboundInteractionCallTranscriptionResultsGet',
        file: 'interactions',
        hasBody: false,
      },
      create: {
        name: 'internalUnboundInteractionSubmitCallTranscriptionRequest',
        file: 'interactions',
        hasBody: false,
      },
      update: {
        name: 'internalUnboundInteractionCallTranscriptionResultsUpdate',
        file: 'interactions',
        hasBody: true,
      },
      actions: [
        {
          name: 'unboundInteractionCallTranscriptionResultsGetByInteraction',
          file: 'interactions',
          hasBody: false,
        },
        {
          name: 'unboundInteractionCallTranscriptionResultsGet',
          file: 'interactions',
          hasBody: false,
        },
        {
          name: 'unboundInteractionSubmitCallTranscriptionRequest',
          file: 'interactions',
          hasBody: false,
        },
        {
          name: 'unboundInteractionCallTranscriptionResultsUpdate',
          file: 'interactions',
          hasBody: true,
        },
      ],
    },
    formSchemas: {
      response: 'interactionCallTranscriptsResponse',
      request: 'interactionCallTranscriptsRequest',
    },
  },
  interactionCallTranscriptSummaries: {
    key: 'interactionCallTranscriptSummaries',
    path: '/companies/{companyId}/interactions/{interactionId}/call-transcripts/{aICallTranscriptionResultId}/summaries',
    scope: 'company',
    pathParams: ['companyId', 'interactionId', 'aICallTranscriptionResultId'],
    label: {
      singular: 'Summary',
      plural: 'Summaries',
    },
    idParam: 'aICallSummaryResultId',
    operations: {
      get: {
        name: 'internalUnboundInteractionCallSummaryResultsGet',
        file: 'interactions',
        hasBody: false,
      },
      create: {
        name: 'internalUnboundInteractionSubmitCallSummaryRequest',
        file: 'interactions',
        hasBody: false,
      },
      update: {
        name: 'internalUnboundInteractionCallSummaryResultsUpdate',
        file: 'interactions',
        hasBody: true,
      },
      actions: [
        {
          name: 'unboundInteractionCallSummaryResultsGet',
          file: 'interactions',
          hasBody: false,
        },
        {
          name: 'unboundInteractionSubmitCallSummaryRequest',
          file: 'interactions',
          hasBody: false,
        },
        {
          name: 'unboundInteractionCallSummaryResultsUpdate',
          file: 'interactions',
          hasBody: true,
        },
      ],
    },
    formSchemas: {
      response: 'interactionCallTranscriptSummariesResponse',
      request: 'interactionCallTranscriptSummariesRequest',
    },
  },
  interactionCases: {
    key: 'interactionCases',
    path: '/people/{personId}/interactions/{interactionId}/cases',
    scope: 'person',
    pathParams: ['personId', 'interactionId'],
    label: {
      singular: 'Case',
      plural: 'Cases',
    },
    operations: {
      list: {
        name: 'getInteractionCases',
        file: 'interactions',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'interactionCasesResponse',
    },
  },
  interactionConvoClose: {
    key: 'interactionConvoClose',
    path: '/companies/{companyId}/interactions/{interactionId}/convo/close',
    scope: 'company',
    pathParams: ['companyId', 'interactionId'],
    label: {
      singular: 'Close',
      plural: 'Closes',
    },
    operations: {
      create: {
        name: 'internalInteractionConvoClose',
        file: 'interactions',
        hasBody: false,
      },
      actions: [
        {
          name: 'interactionConvoClose',
          file: 'interactions',
          hasBody: false,
        },
      ],
    },
  },
  interactionConvoJoin: {
    key: 'interactionConvoJoin',
    path: '/companies/{companyId}/interactions/{interactionId}/convo/join',
    scope: 'company',
    pathParams: ['companyId', 'interactionId'],
    label: {
      singular: 'Join',
      plural: 'Joins',
    },
    operations: {
      create: {
        name: 'internalInteractionConvoJoin',
        file: 'interactions',
        hasBody: true,
      },
      actions: [
        {
          name: 'interactionConvoJoin',
          file: 'interactions',
          hasBody: true,
        },
      ],
    },
    formSchemas: {
      request: 'interactionConvoJoinRequest',
    },
  },
  interactionConvoLeave: {
    key: 'interactionConvoLeave',
    path: '/companies/{companyId}/interactions/{interactionId}/convo/leave',
    scope: 'company',
    pathParams: ['companyId', 'interactionId'],
    label: {
      singular: 'Leave',
      plural: 'Leaves',
    },
    operations: {
      create: {
        name: 'internalInteractionConvoLeave',
        file: 'interactions',
        hasBody: false,
      },
      actions: [
        {
          name: 'interactionConvoLeave',
          file: 'interactions',
          hasBody: false,
        },
      ],
    },
  },
  interactionNotes: {
    key: 'interactionNotes',
    path: '/interactions/{interactionId}/notes',
    scope: 'global',
    pathParams: ['interactionId'],
    label: {
      singular: 'Note',
      plural: 'Notes',
    },
    idParam: 'noteId',
    operations: {
      list: {
        name: 'listInteractionNotes',
        file: 'api-public',
        hasBody: false,
      },
      get: {
        name: 'getInteractionNote',
        file: 'api-public',
        hasBody: false,
      },
      create: {
        name: 'createInteractionNote',
        file: 'api-public',
        hasBody: true,
      },
      update: {
        name: 'updateInteractionNote',
        file: 'api-public',
        hasBody: true,
      },
    },
    formSchemas: {
      response: 'interactionNotesResponse',
      request: 'interactionNotesRequest',
    },
  },
  interactions: {
    key: 'interactions',
    path: '/companies/{companyId}/interactions',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Interaction',
      plural: 'Interactions',
    },
    idParam: 'interactionId',
    operations: {
      list: {
        name: 'internalUnboundInteractionGetAll',
        file: 'interactions',
        hasBody: false,
      },
      get: {
        name: 'internalUnboundInteractionGetById',
        file: 'interactions',
        hasBody: false,
      },
      create: {
        name: 'unboundInteractionAdd',
        file: 'interactions',
        hasBody: true,
      },
      update: {
        name: 'unboundInteractionUpdate',
        file: 'interactions',
        hasBody: true,
      },
      delete: {
        name: 'internalUnboundInteractionDelete',
        file: 'interactions',
        hasBody: false,
      },
      actions: [
        {
          name: 'internalUnboundGetManyPreviousInteractions',
          file: 'interactions',
          hasBody: false,
        },
        {
          name: 'internalInteractionConvoGet',
          file: 'interactions',
          hasBody: false,
        },
        {
          name: 'internalUnboundInteractionDownloadRecording',
          file: 'interactions',
          hasBody: false,
        },
        {
          name: 'internalUnboundInteractionDownloadVoicemail',
          file: 'interactions',
          hasBody: false,
        },
        {
          name: 'unboundInteractionGetAll',
          file: 'interactions',
          hasBody: false,
        },
        {
          name: 'unboundInteractionGetById',
          file: 'interactions',
          hasBody: false,
        },
        {
          name: 'unboundInteractionDelete',
          file: 'interactions',
          hasBody: false,
        },
        {
          name: 'unboundGetManyPreviousInteractions',
          file: 'interactions',
          hasBody: false,
        },
        {
          name: 'interactionConvoGet',
          file: 'interactions',
          hasBody: false,
        },
        {
          name: 'unboundInteractionDownloadRecording',
          file: 'interactions',
          hasBody: false,
        },
        {
          name: 'unboundInteractionDownloadVoicemail',
          file: 'interactions',
          hasBody: false,
        },
      ],
    },
  },
  interest: {
    key: 'interest',
    path: '/people/{personId}/loans/{loanId}/interest',
    scope: 'loan',
    pathParams: ['personId', 'loanId'],
    label: {
      singular: 'Interest',
      plural: 'Interests',
    },
    operations: {
      list: {
        name: 'loanInterestGet',
        file: 'api-public',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'interestResponse',
    },
  },
  internalHasher: {
    key: 'internalHasher',
    path: '/internal/hasher',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Hasher',
      plural: 'Hashers',
    },
    operations: {
      create: {
        name: 'hasher',
        file: 'api-internal',
        hasBody: true,
      },
    },
    formSchemas: {
      request: 'internalHasherRequest',
    },
    companyAmbiguous: true,
  },
  internalOperations: {
    key: 'internalOperations',
    path: '/internal/operations',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Operation',
      plural: 'Operations',
    },
    idParam: 'operationId',
    operations: {
      get: {
        name: 'internalOperationStatusGet',
        file: 'api-internal',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'internalOperationsResponse',
    },
    companyAmbiguous: true,
  },
  investors: {
    key: 'investors',
    path: '/companies/{companyId}/investors',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Investor',
      plural: 'Investors',
    },
    idParam: 'investorId',
    operations: {
      list: {
        name: 'investorGetAll',
        file: 'api-internal',
        hasBody: false,
      },
      get: {
        name: 'investorGet',
        file: 'api-internal',
        hasBody: false,
      },
      create: {
        name: 'investorCreate',
        file: 'api-internal',
        hasBody: true,
      },
      update: {
        name: 'investorUpdate',
        file: 'api-internal',
        hasBody: true,
      },
    },
    formSchemas: {
      response: 'investorsResponse',
      request: 'investorsRequest',
    },
  },
  keys: {
    key: 'keys',
    path: '/companies/{companyId}/keys',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Key',
      plural: 'Keys',
    },
    idParam: 'keyId',
    operations: {
      list: {
        name: 'internalCompanyApiKeysGetAll',
        file: 'api-keys',
        hasBody: false,
      },
      get: {
        name: 'internalCompanyApiKeyGet',
        file: 'api-keys',
        hasBody: false,
      },
      create: {
        name: 'internalCompanyApiKeyCreate',
        file: 'api-keys',
        hasBody: true,
      },
      update: {
        name: 'internalCompanyApiKeyUpdate',
        file: 'api-keys',
        hasBody: true,
      },
      delete: {
        name: 'internalCompanyApiKeyDelete',
        file: 'api-keys',
        hasBody: false,
      },
      actions: [
        {
          name: 'companyApiKeysGetAll',
          file: 'api-keys',
          hasBody: false,
        },
        {
          name: 'companyApiKeyGet',
          file: 'api-keys',
          hasBody: false,
        },
        {
          name: 'companyApiKeyCreate',
          file: 'api-keys',
          hasBody: true,
        },
        {
          name: 'companyApiKeyUpdate',
          file: 'api-keys',
          hasBody: true,
        },
        {
          name: 'companyApiKeyDelete',
          file: 'api-keys',
          hasBody: false,
        },
      ],
    },
    formSchemas: {
      response: 'keysResponse',
      request: 'keysRequest',
      updateRequest: 'keysUpdateRequest',
    },
  },
  ledgerDebugger: {
    key: 'ledgerDebugger',
    path: '/companies/{companyId}/people/{personId}/loans/{loanId}/ledger-debugger',
    scope: 'loan',
    pathParams: ['companyId', 'personId', 'loanId'],
    label: {
      singular: 'Ledger Debugger',
      plural: 'Ledger Debuggers',
    },
    operations: {
      list: {
        name: 'ledgerDebugger',
        file: 'api-internal',
        hasBody: false,
      },
    },
  },
  legalRepresentatives: {
    key: 'legalRepresentatives',
    path: '/people/{personId}/legal-representatives',
    scope: 'person',
    pathParams: ['personId'],
    label: {
      singular: 'Legal Representative',
      plural: 'Legal Representatives',
    },
    idParam: 'legalRepresentativeId',
    operations: {
      list: {
        name: 'legalRepresentativeGetAll',
        file: 'api-public',
        hasBody: false,
      },
      get: {
        name: 'legalRepresentativeGetById',
        file: 'api-public',
        hasBody: false,
      },
      create: {
        name: 'legalRepresentativeAdd',
        file: 'api-public',
        hasBody: true,
      },
      update: {
        name: 'legalRepresentativeUpdate',
        file: 'api-public',
        hasBody: true,
      },
    },
    formSchemas: {
      response: 'legalRepresentativesResponse',
      request: 'legalRepresentativesRequest',
    },
  },
  lithic: {
    key: 'lithic',
    path: '/lithic',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Lithic',
      plural: 'Lithics',
    },
    operations: {
      actions: [
        {
          name: 'lithicReceiveEvent',
          file: 'card-issuers',
          hasBody: true,
        },
        {
          name: 'receiveAsa',
          file: 'card-issuers',
          hasBody: true,
        },
      ],
    },
    companyAmbiguous: true,
  },
  loanCount: {
    key: 'loanCount',
    path: '/companies/{companyId}/loan-count',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Loan Count',
      plural: 'Loan Counts',
    },
    operations: {
      list: {
        name: 'internalLoansGetCount',
        file: 'api-internal',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'loanCountResponse',
    },
  },
  loanDataForApplyPayments: {
    key: 'loanDataForApplyPayments',
    path: '/companies/{companyId}/people/{personId}/loans/{loanId}/loan-data-for-apply-payments',
    scope: 'loan',
    pathParams: ['companyId', 'personId', 'loanId'],
    label: {
      singular: 'Loan Data For Apply Payment',
      plural: 'Loan Data For Apply Payments',
    },
    operations: {
      list: {
        name: 'getLoanDataForApplyPayments',
        file: 'transactions-internal',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'loanDataForApplyPaymentsResponse',
    },
  },
  loanIngest: {
    key: 'loanIngest',
    path: '/companies/{companyId}/loans/{loanId}/loan-ingest',
    scope: 'loan',
    pathParams: ['companyId', 'loanId'],
    label: {
      singular: 'Loan Ingest',
      plural: 'Loan Ingests',
    },
    operations: {
      list: {
        name: 'getLoanData',
        file: 'api-internal',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'loanIngestResponse',
    },
  },
  loanLabelLoanRemove: {
    key: 'loanLabelLoanRemove',
    path: '/companies/{companyId}/loan-labels/{loanLabelIds}/loans/remove',
    scope: 'company',
    pathParams: ['companyId', 'loanLabelIds'],
    label: {
      singular: 'Remove',
      plural: 'Removes',
    },
    operations: {
      update: {
        name: 'loanLabelsRemoveLoans',
        file: 'loan-labels',
        hasBody: true,
      },
    },
    formSchemas: {
      request: 'loanLabelLoanRemoveRequest',
    },
  },
  loanLabels: {
    key: 'loanLabels',
    path: '/companies/{companyId}/loan-labels',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Loan Label',
      plural: 'Loan Labels',
    },
    idParam: 'loanLabelId',
    operations: {
      list: {
        name: 'loanLabelsList',
        file: 'loan-labels',
        hasBody: false,
      },
      get: {
        name: 'loanLabelGet',
        file: 'loan-labels',
        hasBody: false,
      },
      create: {
        name: 'loanLabelCreate',
        file: 'loan-labels',
        hasBody: true,
      },
      update: {
        name: 'loanLabelUpdate',
        file: 'loan-labels',
        hasBody: true,
      },
      delete: {
        name: 'loanLabelDelete',
        file: 'loan-labels',
        hasBody: false,
      },
      actions: [
        {
          name: 'loanLabelsGetLoans',
          file: 'loan-labels',
          hasBody: false,
        },
        {
          name: 'loanLabelsAddLoans',
          file: 'loan-labels',
          hasBody: true,
        },
      ],
    },
    formSchemas: {
      response: 'loanLabelsResponse',
      request: 'loanLabelsRequest',
    },
  },
  loanPeriods: {
    key: 'loanPeriods',
    path: '/loan-periods',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Loan Period',
      plural: 'Loan Periods',
    },
    operations: {
      list: {
        name: 'getPeriods',
        file: 'api-internal',
        hasBody: false,
      },
      actions: [
        {
          name: 'createStatement',
          file: 'api-internal',
          hasBody: true,
        },
      ],
    },
    formSchemas: {
      response: 'loanPeriodsResponse',
    },
    companyAmbiguous: true,
  },
  loans: {
    key: 'loans',
    path: '/companies/{companyId}/loans',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Loan',
      plural: 'Loans',
    },
    idParam: 'loanId',
    operations: {
      list: {
        name: 'internalLoansGetByCompany',
        file: 'api-internal',
        hasBody: false,
      },
      get: {
        name: 'getLoan',
        file: 'api-internal',
        hasBody: false,
      },
      actions: [
        {
          name: 'internalEvaluatePromiseToPayPlan',
          file: 'promise-to-pay',
          hasBody: false,
        },
        {
          name: 'processScheduledReversalsForLoan',
          file: 'transactions-internal',
          hasBody: false,
        },
        {
          name: 'transactionsCreateVirtualsSet',
          file: 'transactions-internal',
          hasBody: true,
        },
        {
          name: 'loansGetByCompany',
          file: 'api-public',
          hasBody: false,
        },
        {
          name: 'internalLoanDrawLocIdGet',
          file: 'api-internal',
          hasBody: false,
        },
      ],
    },
  },
  loanTapeDue: {
    key: 'loanTapeDue',
    path: '/loan-tapes/due',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Due',
      plural: 'Dues',
    },
    operations: {
      list: {
        name: 'loanTapesDue',
        file: 'loantapes',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'loanTapeDueResponse',
    },
    companyAmbiguous: true,
  },
  loanTapeLoans: {
    key: 'loanTapeLoans',
    path: '/companies/{companyId}/loan-tapes/{loanTapeId}/loans',
    scope: 'company',
    pathParams: ['companyId', 'loanTapeId'],
    label: {
      singular: 'Loan',
      plural: 'Loans',
    },
    operations: {
      list: {
        name: 'getAllLoansForLoanTape',
        file: 'loantapes',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'loanTapeLoansResponse',
    },
  },
  loanTapeRecords: {
    key: 'loanTapeRecords',
    path: '/companies/{companyId}/loan-tapes/{loanTapeId}/records',
    scope: 'company',
    pathParams: ['companyId', 'loanTapeId'],
    label: {
      singular: 'Record',
      plural: 'Records',
    },
    idParam: 'loanTapeRecordId',
    operations: {
      list: {
        name: 'loanTapeRecordsList',
        file: 'loantapes',
        hasBody: false,
      },
      create: {
        name: 'loanTapeRecordCreate',
        file: 'loantapes',
        hasBody: true,
      },
      update: {
        name: 'loanTapeRecordUpdate',
        file: 'loantapes',
        hasBody: true,
      },
    },
    formSchemas: {
      response: 'loanTapeRecordsResponse',
      request: 'loanTapeRecordsRequest',
    },
  },
  loanTapes: {
    key: 'loanTapes',
    path: '/companies/{companyId}/loan-tapes',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Loan Tape',
      plural: 'Loan Tapes',
    },
    idParam: 'loanTapeId',
    operations: {
      list: {
        name: 'loanTapesList',
        file: 'loantapes',
        hasBody: false,
      },
      get: {
        name: 'loanTapeGet',
        file: 'loantapes',
        hasBody: false,
      },
      create: {
        name: 'loanTapeCreate',
        file: 'loantapes',
        hasBody: true,
      },
      update: {
        name: 'loanTapeUpdate',
        file: 'loantapes',
        hasBody: true,
      },
      delete: {
        name: 'loanTapeDelete',
        file: 'loantapes',
        hasBody: false,
      },
      actions: [
        {
          name: 'loanTapesGenerate',
          file: 'loantapes',
          hasBody: true,
        },
      ],
    },
    formSchemas: {
      response: 'loanTape',
    },
  },
  loanTapeTypes: {
    key: 'loanTapeTypes',
    path: '/companies/{companyId}/loan-tape-types',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Loan Tape Type',
      plural: 'Loan Tape Types',
    },
    idParam: 'loanTapeTypeId',
    operations: {
      list: {
        name: 'loanTapeTypesList',
        file: 'loantapes',
        hasBody: false,
      },
      get: {
        name: 'loanTapeTypeGet',
        file: 'loantapes',
        hasBody: false,
      },
      create: {
        name: 'loanTapeTypeCreate',
        file: 'loantapes',
        hasBody: true,
      },
      update: {
        name: 'loanTapeTypeUpdate',
        file: 'loantapes',
        hasBody: true,
      },
      delete: {
        name: 'loanTapeTypeDelete',
        file: 'loantapes',
        hasBody: false,
      },
      actions: [
        {
          name: 'loanTapeTypeData',
          file: 'loantapes',
          hasBody: false,
        },
      ],
    },
    formSchemas: {
      response: 'loanTapeType',
    },
  },
  loanTypeDynamicFeeTypes: {
    key: 'loanTypeDynamicFeeTypes',
    path: '/companies/{companyId}/loan-types/{loanTypeId}/dynamic-fee-types',
    scope: 'company',
    pathParams: ['companyId', 'loanTypeId'],
    label: {
      singular: 'Dynamic Fee Type',
      plural: 'Dynamic Fee Types',
    },
    idParam: 'dynamicFeeTypeId',
    operations: {
      list: {
        name: 'loanTypeDynamicFeeGetAll',
        file: 'loan-types',
        hasBody: false,
      },
      get: {
        name: 'loanTypeDynamicFeeTypeGet',
        file: 'loan-types',
        hasBody: false,
      },
      create: {
        name: 'loanTypeDynamicFeeTypeAdd',
        file: 'loan-types',
        hasBody: true,
      },
    },
    formSchemas: {
      response: 'loanTypeDynamicFeeTypesResponse',
      request: 'loanTypeDynamicFeeTypesRequest',
    },
  },
  loanTypeIndexRates: {
    key: 'loanTypeIndexRates',
    path: '/companies/{companyId}/loan-types/{loanTypeId}/index-rates',
    scope: 'company',
    pathParams: ['companyId', 'loanTypeId'],
    label: {
      singular: 'Index Rate',
      plural: 'Index Rates',
    },
    idParam: 'indexRateId',
    operations: {
      list: {
        name: 'internalLoanTypeIndexRateGetAll',
        file: 'loan-types',
        hasBody: false,
      },
      get: {
        name: 'internalLoanTypeIndexRateGet',
        file: 'loan-types',
        hasBody: false,
      },
      create: {
        name: 'internalLoanTypeIndexRateAdd',
        file: 'loan-types',
        hasBody: true,
      },
      update: {
        name: 'internalLoanTypeIndexRateUpdate',
        file: 'loan-types',
        hasBody: true,
      },
      delete: {
        name: 'internalLoanTypeIndexRateDelete',
        file: 'loan-types',
        hasBody: false,
      },
      actions: [
        {
          name: 'loanTypeIndexRateGetAll',
          file: 'loan-types',
          hasBody: false,
        },
        {
          name: 'loanTypeIndexRateGet',
          file: 'loan-types',
          hasBody: false,
        },
        {
          name: 'loanTypeIndexRateAdd',
          file: 'loan-types',
          hasBody: true,
        },
        {
          name: 'loanTypeIndexRateUpdate',
          file: 'loan-types',
          hasBody: true,
        },
        {
          name: 'loanTypeIndexRateDelete',
          file: 'loan-types',
          hasBody: false,
        },
      ],
    },
    formSchemas: {
      response: 'loanTypeIndexRatesResponse',
      request: 'loanTypeIndexRatesRequest',
    },
  },
  loanTypeLoans: {
    key: 'loanTypeLoans',
    path: '/companies/{companyId}/loan-types/{loanTypeId}/loans',
    scope: 'company',
    pathParams: ['companyId', 'loanTypeId'],
    label: {
      singular: 'Loan',
      plural: 'Loans',
    },
    operations: {
      list: {
        name: 'loansGetByLoanType',
        file: 'loan-types',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'loanTypeLoansResponse',
    },
  },
  loanTypeRepaymentEngine: {
    key: 'loanTypeRepaymentEngine',
    path: '/companies/{companyId}/loan-types/{loanTypeId}/repayment-engine',
    scope: 'company',
    pathParams: ['companyId', 'loanTypeId'],
    label: {
      singular: 'Repayment Engine',
      plural: 'Repayment Engines',
    },
    idParam: 'repaymentNotificationTypeId',
    operations: {
      get: {
        name: 'getNotificationTypeById',
        file: 'repayment-engine',
        hasBody: false,
      },
      update: {
        name: 'updateNotificationTypeInternal',
        file: 'repayment-engine',
        hasBody: true,
      },
      delete: {
        name: 'deleteNotificationTypeInternal',
        file: 'repayment-engine',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'loanTypeRepaymentEngineResponse',
      request: 'loanTypeRepaymentEngineRequest',
    },
  },
  loanTypeRepaymentEngineNotifications: {
    key: 'loanTypeRepaymentEngineNotifications',
    path: '/companies/{companyId}/loan-types/{loanTypeId}/repayment-engine/notifications',
    scope: 'company',
    pathParams: ['companyId', 'loanTypeId'],
    label: {
      singular: 'Notification',
      plural: 'Notifications',
    },
    operations: {
      list: {
        name: 'getNotificationTypesInternal',
        file: 'repayment-engine',
        hasBody: false,
      },
      create: {
        name: 'createNotificationTypeInternal',
        file: 'repayment-engine',
        hasBody: true,
      },
    },
    formSchemas: {
      request: 'loanTypeRepaymentEngineNotificationsRequest',
    },
  },
  loanTypeRepaymentEngineReminders: {
    key: 'loanTypeRepaymentEngineReminders',
    path: '/companies/{companyId}/loan-types/{loanTypeId}/repayment-engine/{repaymentNotificationTypeId}/reminders',
    scope: 'company',
    pathParams: ['companyId', 'loanTypeId', 'repaymentNotificationTypeId'],
    label: {
      singular: 'Reminder',
      plural: 'Reminders',
    },
    operations: {
      list: {
        name: 'getNotificationDataInternal',
        file: 'repayment-engine',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'loanTypeRepaymentEngineRemindersResponse',
    },
  },
  loanTypes: {
    key: 'loanTypes',
    path: '/companies/{companyId}/loan-types',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Loan Type',
      plural: 'Loan Types',
    },
    idParam: 'loanTypeId',
    operations: {
      list: {
        name: 'companyLoanConfigurationsGetAll',
        file: 'loan-types',
        hasBody: false,
      },
      get: {
        name: 'companyLoanConfigurationsGet',
        file: 'loan-types',
        hasBody: false,
      },
      create: {
        name: 'companyLoanConfigurationsAdd',
        file: 'loan-types',
        hasBody: true,
      },
      update: {
        name: 'companyLoanConfigurationsUpdate',
        file: 'loan-types',
        hasBody: true,
      },
      delete: {
        name: 'companyLoanConfigurationsDelete',
        file: 'loan-types',
        hasBody: false,
      },
      actions: [
        {
          name: 'internalFeeTypesGet',
          file: 'loan-types',
          hasBody: false,
        },
        {
          name: 'transactionsGetLoansWithScheduledReversals',
          file: 'loan-types',
          hasBody: false,
        },
        {
          name: 'getLoanTypeCompanyConfigOverride',
          file: 'loan-types',
          hasBody: false,
        },
        {
          name: 'setLoanTypeCompanyConfigOverride',
          file: 'loan-types',
          hasBody: true,
        },
        {
          name: 'getLoanTypeChargedoffPaidoffPeriodsWithoutStatements',
          file: 'loan-types',
          hasBody: false,
        },
        {
          name: 'feeTypesGet',
          file: 'loan-types',
          hasBody: false,
        },
      ],
    },
    formSchemas: {
      response: 'loanTypesResponse',
      updateRequest: 'loanTypesUpdateRequest',
    },
  },
  loanTypeTransactions: {
    key: 'loanTypeTransactions',
    path: '/companies/{companyId}/loan-types/{loanTypeId}/transactions',
    scope: 'company',
    pathParams: ['companyId', 'loanTypeId'],
    label: {
      singular: 'Transaction',
      plural: 'Transactions',
    },
    operations: {
      list: {
        name: 'transactionsGetRawInternalHandler',
        file: 'loan-types',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'loanTypeTransactionsResponse',
    },
  },
  lockStatus: {
    key: 'lockStatus',
    path: '/people/{personId}/loans/{loanId}/lock-status',
    scope: 'loan',
    pathParams: ['personId', 'loanId'],
    label: {
      singular: 'Lock Status',
      plural: 'Lock Statuses',
    },
    operations: {
      list: {
        name: 'getLockStatus',
        file: 'api-public',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'lockStatusResponse',
    },
  },
  locPaymentPlanScra: {
    key: 'locPaymentPlanScra',
    path: '/companies/{companyId}/people/{personId}/loans/{loanId}/loc-payment-plan-scra',
    scope: 'loan',
    pathParams: ['companyId', 'personId', 'loanId'],
    label: {
      singular: 'Loc Payment Plan Scra',
      plural: 'Loc Payment Plan Scras',
    },
    operations: {
      create: {
        name: 'aliasLocChangeTermsScraCreate',
        file: 'scra',
        hasBody: true,
      },
      update: {
        name: 'aliasLocChangeTermsScraUpdate',
        file: 'scra',
        hasBody: true,
      },
      actions: [
        {
          name: 'aliasLocChangeTermsScraDelete',
          file: 'scra',
          hasBody: false,
        },
        {
          name: 'locChangeTermsScraCreate',
          file: 'scra',
          hasBody: true,
        },
        {
          name: 'locChangeTermsScraUpdate',
          file: 'scra',
          hasBody: true,
        },
        {
          name: 'locChangeTermsScraDelete',
          file: 'scra',
          hasBody: false,
        },
      ],
    },
    formSchemas: {
      request: 'locPaymentPlanScraRequest',
    },
  },
  marqeta: {
    key: 'marqeta',
    path: '/marqeta',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Marqeta',
      plural: 'Marqetas',
    },
    operations: {
      actions: [
        {
          name: 'marqetaReceiveEvent',
          file: 'card-issuers',
          hasBody: true,
        },
        {
          name: 'receiveJit',
          file: 'card-issuers',
          hasBody: true,
        },
      ],
    },
    companyAmbiguous: true,
  },
  merchants: {
    key: 'merchants',
    path: '/companies/{companyId}/merchants',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Merchant',
      plural: 'Merchants',
    },
    idParam: 'merchantId',
    operations: {
      list: {
        name: 'merchantsList',
        file: 'merchants',
        hasBody: false,
      },
      get: {
        name: 'merchantGet',
        file: 'merchants',
        hasBody: false,
      },
      create: {
        name: 'merchantCreate',
        file: 'merchants',
        hasBody: true,
      },
      update: {
        name: 'merchantUpdate',
        file: 'merchants',
        hasBody: true,
      },
    },
    formSchemas: {
      response: 'merchantsResponse',
      request: 'merchantsRequest',
    },
  },
  migrationPastPeriods: {
    key: 'migrationPastPeriods',
    path: '/people/{personId}/loans/{loanId}/migration/past-periods',
    scope: 'loan',
    pathParams: ['personId', 'loanId'],
    label: {
      singular: 'Past Period',
      plural: 'Past Periods',
    },
    operations: {
      list: {
        name: 'pastPeriodsDataList',
        file: 'loc-migration',
        hasBody: false,
      },
      create: {
        name: 'pastPeriodsDataCreate',
        file: 'loc-migration',
        hasBody: true,
      },
      update: {
        name: 'pastPeriodsDataUpdate',
        file: 'loc-migration',
        hasBody: true,
      },
      actions: [
        {
          name: 'pastPeriodsDataDelete',
          file: 'loc-migration',
          hasBody: false,
        },
      ],
    },
    formSchemas: {
      response: 'migrationPastPeriodsResponse',
      request: 'migrationPastPeriodsRequest',
    },
  },
  migrationPastTransaction: {
    key: 'migrationPastTransaction',
    path: '/people/{personId}/loans/{loanId}/migration/past-transaction',
    scope: 'loan',
    pathParams: ['personId', 'loanId'],
    label: {
      singular: 'Past Transaction',
      plural: 'Past Transactions',
    },
    idParam: 'transactionId',
    operations: {
      list: {
        name: 'pastTransactionDataGetAll',
        file: 'loc-migration',
        hasBody: false,
      },
      get: {
        name: 'pastTransactionDataGetOne',
        file: 'loc-migration',
        hasBody: false,
      },
      create: {
        name: 'pastTransactionDataCreate',
        file: 'loc-migration',
        hasBody: true,
      },
      update: {
        name: 'pastTransactionDataUpdate',
        file: 'loc-migration',
        hasBody: true,
      },
    },
    formSchemas: {
      response: 'migrationPastTransactionResponse',
    },
  },
  migrationPeriod: {
    key: 'migrationPeriod',
    path: '/people/{personId}/loans/{loanId}/migration/period',
    scope: 'loan',
    pathParams: ['personId', 'loanId'],
    label: {
      singular: 'Period',
      plural: 'Periods',
    },
    operations: {
      list: {
        name: 'migrationPeriodLocGet',
        file: 'loc-migration',
        hasBody: false,
      },
      create: {
        name: 'migrationPeriodLocCreate',
        file: 'loc-migration',
        hasBody: true,
      },
      update: {
        name: 'migrationPeriodLocUpdate',
        file: 'loc-migration',
        hasBody: true,
      },
    },
    formSchemas: {
      response: 'migrationPeriodResponse',
    },
  },
  migrationStatus: {
    key: 'migrationStatus',
    path: '/companies/{companyId}/people/{personId}/loans/{loanId}/migration-status',
    scope: 'loan',
    pathParams: ['companyId', 'personId', 'loanId'],
    label: {
      singular: 'Migration Status',
      plural: 'Migration Statuses',
    },
    operations: {
      update: {
        name: 'loanUpdateMigrationStatus',
        file: 'api-internal',
        hasBody: true,
      },
    },
    formSchemas: {
      request: 'migrationStatusRequest',
    },
  },
  monitoringServiceDueStatuses: {
    key: 'monitoringServiceDueStatuses',
    path: '/companies/{companyId}/monitoring/services/{serviceId}/due-statuses',
    scope: 'company',
    pathParams: ['companyId', 'serviceId'],
    label: {
      singular: 'Due Status',
      plural: 'Due Statuses',
    },
    operations: {
      list: {
        name: 'dueStatuses',
        file: 'api-internal',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'monitoringServiceDueStatusesResponse',
    },
  },
  monitoringServices: {
    key: 'monitoringServices',
    path: '/companies/{companyId}/monitoring/services',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Service',
      plural: 'Services',
    },
    idParam: 'serviceId',
    operations: {
      list: {
        name: 'servicesGetAll',
        file: 'api-internal',
        hasBody: false,
      },
      get: {
        name: 'servicesGet',
        file: 'api-internal',
        hasBody: false,
      },
      create: {
        name: 'serviceCreate',
        file: 'api-internal',
        hasBody: true,
      },
      actions: [
        {
          name: 'serviceCreateBulk',
          file: 'api-internal',
          hasBody: true,
        },
      ],
    },
    formSchemas: {
      response: 'monitoringServicesResponse',
      request: 'monitoringServicesRequest',
    },
  },
  monitoringStatus: {
    key: 'monitoringStatus',
    path: '/companies/{companyId}/people/{personId}/monitoring-status',
    scope: 'person',
    pathParams: ['companyId', 'personId'],
    label: {
      singular: 'Monitoring Status',
      plural: 'Monitoring Statuses',
    },
    idParam: 'statusId',
    operations: {
      list: {
        name: 'internalStatusGetAll',
        file: 'api-internal',
        hasBody: false,
      },
      get: {
        name: 'statusGet',
        file: 'api-internal',
        hasBody: false,
      },
      create: {
        name: 'statusCreate',
        file: 'api-internal',
        hasBody: true,
      },
      update: {
        name: 'internalStatusUpdate',
        file: 'api-internal',
        hasBody: true,
      },
      actions: [
        {
          name: 'statusGetAll',
          file: 'api-internal',
          hasBody: false,
        },
        {
          name: 'statusUpdate',
          file: 'api-internal',
          hasBody: true,
        },
      ],
    },
    formSchemas: {
      response: 'monitoringStatusResponse',
      request: 'monitoringStatusRequest',
    },
  },
  monitoringStatusGlobal: {
    key: 'monitoringStatusGlobal',
    path: '/monitoring-status',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Monitoring Status',
      plural: 'Monitoring Statuses',
    },
    operations: {
      list: {
        name: 'allStatuses',
        file: 'api-internal',
        hasBody: false,
      },
      update: {
        name: 'updateStatuses',
        file: 'api-internal',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'monitoringStatusGlobalResponse',
    },
    companyAmbiguous: true,
  },
  notes: {
    key: 'notes',
    path: '/people/{personId}/notes',
    scope: 'person',
    pathParams: ['personId'],
    label: {
      singular: 'Note',
      plural: 'Notes',
    },
    idParam: 'noteId',
    operations: {
      list: {
        name: 'listBorrowerNotes',
        file: 'api-public',
        hasBody: false,
      },
      get: {
        name: 'getBorrowerNote',
        file: 'api-public',
        hasBody: false,
      },
      create: {
        name: 'createBorrowerNote',
        file: 'api-public',
        hasBody: true,
      },
      update: {
        name: 'updateBorrowerNote',
        file: 'api-public',
        hasBody: true,
      },
    },
    formSchemas: {
      response: 'notesResponse',
      request: 'notesRequest',
    },
  },
  notificationTypes: {
    key: 'notificationTypes',
    path: '/notification-types',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Notification Type',
      plural: 'Notification Types',
    },
    idParam: 'notificationTypeId',
    operations: {
      list: {
        name: 'notificationTypeGetAll',
        file: 'api-public',
        hasBody: false,
      },
      get: {
        name: 'notificationTypeGetById',
        file: 'api-public',
        hasBody: false,
      },
      create: {
        name: 'notificationTypeCreate',
        file: 'api-public',
        hasBody: true,
      },
      update: {
        name: 'notificationTypeUpdate',
        file: 'api-public',
        hasBody: true,
      },
    },
    formSchemas: {
      response: 'notificationTypesResponse',
      request: 'notificationTypesRequest',
    },
    companyAmbiguous: true,
  },
  obligationRefreshPreview: {
    key: 'obligationRefreshPreview',
    path: '/companies/{companyId}/people/{personId}/loans/{loanId}/obligations/refresh-preview',
    scope: 'loan',
    pathParams: ['companyId', 'personId', 'loanId'],
    label: {
      singular: 'Refresh Preview',
      plural: 'Refresh Previews',
    },
    operations: {
      list: {
        name: 'obligationsRefreshPreviewForTimestamp',
        file: 'api-internal',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'obligationRefreshPreviewResponse',
    },
  },
  obligations: {
    key: 'obligations',
    path: '/companies/{companyId}/loans/{loanId}/obligations',
    scope: 'loan',
    pathParams: ['companyId', 'loanId'],
    label: {
      singular: 'Obligation',
      plural: 'Obligations',
    },
    operations: {
      list: {
        name: 'getCompanyLoanObligations',
        file: 'api-internal',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'obligationsResponse',
    },
  },
  operations: {
    key: 'operations',
    path: '/operations',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Operation',
      plural: 'Operations',
    },
    idParam: 'operationId',
    operations: {
      get: {
        name: 'operationStatusGet',
        file: 'api-public',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'operationsResponse',
    },
    companyAmbiguous: true,
  },
  paymentInstruments: {
    key: 'paymentInstruments',
    path: '/companies/{companyId}/people/{personId}/payment-instruments',
    scope: 'person',
    pathParams: ['companyId', 'personId'],
    label: {
      singular: 'Payment Instrument',
      plural: 'Payment Instruments',
    },
    idParam: 'paymentInstrumentId',
    operations: {
      list: {
        name: 'internalBorrowerPaymentInstrumentGetAll',
        file: 'api-internal',
        hasBody: false,
      },
      get: {
        name: 'internalBorrowerPaymentInstrumentGet',
        file: 'api-internal',
        hasBody: false,
      },
      create: {
        name: 'internalBorrowerPaymentInstrumentCreate',
        file: 'api-internal',
        hasBody: true,
      },
      update: {
        name: 'internalBorrowerPaymentInstrumentUpdate',
        file: 'api-internal',
        hasBody: true,
      },
      delete: {
        name: 'internalBorrowerPaymentInstrumentDelete',
        file: 'api-internal',
        hasBody: false,
      },
      actions: [
        {
          name: 'internalAccountLinkPost',
          file: 'api-internal',
          hasBody: true,
        },
        {
          name: 'internalAccountLinkDelete',
          file: 'api-internal',
          hasBody: false,
        },
        {
          name: 'internalBalancesGet',
          file: 'api-internal',
          hasBody: false,
        },
        {
          name: 'internalBalancesPost',
          file: 'api-internal',
          hasBody: false,
        },
        {
          name: 'personPaymentInstrumentGetAll',
          file: 'api-public',
          hasBody: false,
        },
        {
          name: 'personPaymentInstrumentGet',
          file: 'api-public',
          hasBody: false,
        },
        {
          name: 'personPaymentInstrumentCreate',
          file: 'api-public',
          hasBody: true,
        },
        {
          name: 'personPaymentInstrumentUpdate',
          file: 'api-public',
          hasBody: true,
        },
        {
          name: 'personPaymentInstrumentDelete',
          file: 'api-public',
          hasBody: false,
        },
        {
          name: 'personPaymentInstrumentVerify',
          file: 'api-public',
          hasBody: true,
        },
        {
          name: 'accountLinkPut',
          file: 'api-public',
          hasBody: true,
        },
        {
          name: 'accountLinkPost',
          file: 'api-public',
          hasBody: true,
        },
        {
          name: 'accountLinkDelete',
          file: 'api-public',
          hasBody: false,
        },
        {
          name: 'balancesGet',
          file: 'api-public',
          hasBody: false,
        },
        {
          name: 'balancesPost',
          file: 'api-public',
          hasBody: false,
        },
      ],
    },
  },
  paymentPlanScra: {
    key: 'paymentPlanScra',
    path: '/companies/{companyId}/people/{personId}/loans/{loanId}/payment-plan-scra',
    scope: 'loan',
    pathParams: ['companyId', 'personId', 'loanId'],
    label: {
      singular: 'Payment Plan Scra',
      plural: 'Payment Plan Scras',
    },
    operations: {
      create: {
        name: 'aliasLoanChangeTermsScraCreate',
        file: 'scra',
        hasBody: true,
      },
      update: {
        name: 'aliasLoanChangeTermsScraUpdate',
        file: 'scra',
        hasBody: true,
      },
      actions: [
        {
          name: 'aliasLoanChangeTermsScraDelete',
          file: 'scra',
          hasBody: false,
        },
        {
          name: 'loanChangeTermsScraCreate',
          file: 'scra',
          hasBody: true,
        },
        {
          name: 'loanChangeTermsScraUpdate',
          file: 'scra',
          hasBody: true,
        },
        {
          name: 'loanChangeTermsScraDelete',
          file: 'scra',
          hasBody: false,
        },
      ],
    },
    formSchemas: {
      request: 'paymentPlanScraRequest',
    },
  },
  paymentProcessorAchFiles: {
    key: 'paymentProcessorAchFiles',
    path: '/companies/{companyId}/payment-processors/{paymentProcessorId}/ach-files',
    scope: 'company',
    pathParams: ['companyId', 'paymentProcessorId'],
    label: {
      singular: 'Ach File',
      plural: 'Ach Files',
    },
    idParam: 'achFileId',
    operations: {
      get: {
        name: 'internalGetOneAchFile',
        file: 'api-internal',
        hasBody: false,
      },
      create: {
        name: 'internalCreateAchFile',
        file: 'api-internal',
        hasBody: true,
      },
      update: {
        name: 'internalUpdateAchFile',
        file: 'api-internal',
        hasBody: true,
      },
      actions: [
        {
          name: 'getAchFileContent',
          file: 'api-public',
          hasBody: false,
        },
      ],
    },
    formSchemas: {
      response: 'paymentProcessorAchFilesResponse',
      request: 'paymentProcessorAchFilesRequest',
    },
  },
  paymentProcessors: {
    key: 'paymentProcessors',
    path: '/companies/{companyId}/payment-processors',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Payment Processor',
      plural: 'Payment Processors',
    },
    idParam: 'paymentProcessorId',
    operations: {
      list: {
        name: 'internalGetPaymentProcessors',
        file: 'api-internal',
        hasBody: false,
      },
      get: {
        name: 'internalGetOnePaymentProcessor',
        file: 'api-internal',
        hasBody: false,
      },
      create: {
        name: 'internalCreatePaymentProcessor',
        file: 'api-internal',
        hasBody: true,
      },
      update: {
        name: 'internalUpdatePaymentProcessor',
        file: 'api-internal',
        hasBody: true,
      },
      delete: {
        name: 'internalDeletePaymentProcessor',
        file: 'api-internal',
        hasBody: false,
      },
      actions: [
        {
          name: 'internalGetAchFiles',
          file: 'api-internal',
          hasBody: false,
        },
        {
          name: 'getPaymentProcessors',
          file: 'api-public',
          hasBody: false,
        },
        {
          name: 'getOnePaymentProcessor',
          file: 'api-public',
          hasBody: false,
        },
        {
          name: 'createPaymentProcessor',
          file: 'api-public',
          hasBody: true,
        },
        {
          name: 'updatePaymentProcessor',
          file: 'api-public',
          hasBody: true,
        },
        {
          name: 'deletePaymentProcessor',
          file: 'api-public',
          hasBody: false,
        },
      ],
    },
    formSchemas: {
      response: 'paymentProcessorsResponse',
      request: 'paymentProcessorsRequest',
    },
  },
  peachy: {
    key: 'peachy',
    path: '/peachy',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Peachy',
      plural: 'Peachies',
    },
    operations: {
      list: {
        name: 'peachy',
        file: 'api-internal',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'peachyResponse',
    },
    companyAmbiguous: true,
  },
  peachyPit: {
    key: 'peachyPit',
    path: '/peachy/pit',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Pit',
      plural: 'Pits',
    },
    operations: {
      list: {
        name: 'pit',
        file: 'api-internal',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'peachyPitResponse',
    },
    companyAmbiguous: true,
  },
  peachyReady: {
    key: 'peachyReady',
    path: '/peachy-ready',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Peachy Ready',
      plural: 'Peachy Readies',
    },
    operations: {
      list: {
        name: 'peachyReady',
        file: 'api-internal',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'peachyReadyResponse',
    },
    companyAmbiguous: true,
  },
  people: {
    key: 'people',
    path: '/companies/{companyId}/people',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Person',
      plural: 'People',
    },
    idParam: 'personId',
    operations: {
      list: {
        name: 'internalBorrowersList',
        file: 'borrowers',
        hasBody: false,
      },
      get: {
        name: 'internalBorrowerGet',
        file: 'borrowers',
        hasBody: false,
      },
      create: {
        name: 'internalBorrowerCreate',
        file: 'borrowers',
        hasBody: true,
      },
      update: {
        name: 'internalBorrowerUpdate',
        file: 'borrowers',
        hasBody: true,
      },
      actions: [
        {
          name: 'internalBorrowerSearch',
          file: 'borrowers',
          hasBody: false,
        },
        {
          name: 'adminBorrowersReindex',
          file: 'borrowers',
          hasBody: true,
        },
        {
          name: 'internalCanInteract',
          file: 'borrowers',
          hasBody: true,
        },
        {
          name: 'borrowersList',
          file: 'borrowers',
          hasBody: false,
        },
        {
          name: 'borrowerGet',
          file: 'borrowers',
          hasBody: false,
        },
        {
          name: 'borrowerCreate',
          file: 'borrowers',
          hasBody: true,
        },
        {
          name: 'borrowerUpdate',
          file: 'borrowers',
          hasBody: true,
        },
        {
          name: 'borrowerSearch',
          file: 'borrowers',
          hasBody: false,
        },
        {
          name: 'canInteract',
          file: 'borrowers',
          hasBody: true,
        },
      ],
    },
  },
  periods: {
    key: 'periods',
    path: '/companies/{companyId}/people/{personId}/loans/{loanId}/periods',
    scope: 'loan',
    pathParams: ['companyId', 'personId', 'loanId'],
    label: {
      singular: 'Period',
      plural: 'Periods',
    },
    idParam: 'loanPeriodId',
    operations: {
      list: {
        name: 'internalGetLoanPeriods',
        file: 'api-internal',
        hasBody: false,
      },
      get: {
        name: 'getLoanPeriodById',
        file: 'api-public',
        hasBody: false,
      },
      create: {
        name: 'internalCreateNextLoanPeriod',
        file: 'api-internal',
        hasBody: true,
      },
      update: {
        name: 'internalUpdateLoanPeriod',
        file: 'api-internal',
        hasBody: true,
      },
      actions: [
        {
          name: 'internalGenerateStatement',
          file: 'api-internal',
          hasBody: false,
        },
        {
          name: 'getLoanPeriods',
          file: 'api-public',
          hasBody: false,
        },
        {
          name: 'generateStatement',
          file: 'api-public',
          hasBody: false,
        },
      ],
    },
    formSchemas: {
      response: 'periodsResponse',
      request: 'periodsRequest',
    },
  },
  permissions: {
    key: 'permissions',
    path: '/companies/{companyId}/permissions',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Permission',
      plural: 'Permissions',
    },
    operations: {
      list: {
        name: 'companyPermissionsGet',
        file: 'api-internal',
        hasBody: false,
      },
    },
  },
  personCaseEscalations: {
    key: 'personCaseEscalations',
    path: '/people/{personId}/cases/{caseId}/escalations',
    scope: 'person',
    pathParams: ['personId', 'caseId'],
    label: {
      singular: 'Escalation',
      plural: 'Escalations',
    },
    idParam: 'caseEscalationId',
    operations: {
      list: {
        name: 'caseEscalationsGet',
        file: 'cases',
        hasBody: false,
      },
      get: {
        name: 'caseEscalationGetById',
        file: 'cases',
        hasBody: false,
      },
      create: {
        name: 'caseEscalationsCreate',
        file: 'cases',
        hasBody: true,
      },
    },
    formSchemas: {
      response: 'personCaseEscalationsResponse',
      request: 'personCaseEscalationsRequest',
    },
  },
  personDocuments: {
    key: 'personDocuments',
    path: '/people/{personId}/documents',
    scope: 'person',
    pathParams: ['personId'],
    label: {
      singular: 'Document',
      plural: 'Documents',
    },
    idParam: 'documentDescriptorId',
    operations: {
      list: {
        name: 'listPersonDocuments',
        file: 'docustore',
        hasBody: false,
      },
      get: {
        name: 'getPersonDocument',
        file: 'docustore',
        hasBody: false,
      },
      create: {
        name: 'createPersonDocument',
        file: 'docustore',
        hasBody: true,
      },
      update: {
        name: 'updatePersonDocument',
        file: 'docustore',
        hasBody: true,
      },
      delete: {
        name: 'deleteDocument',
        file: 'docustore',
        hasBody: false,
      },
      actions: [
        {
          name: 'downloadPersonDocumentContent',
          file: 'docustore',
          hasBody: false,
        },
        {
          name: 'uploadPersonDocumentContent',
          file: 'docustore',
          hasBody: true,
        },
        {
          name: 'convertPersonDocument',
          file: 'docustore',
          hasBody: false,
        },
        {
          name: 'signPersonPdfDocument',
          file: 'docustore',
          hasBody: false,
        },
      ],
    },
    formSchemas: {
      response: 'personDocumentsResponse',
      request: 'personDocumentsRequest',
    },
  },
  personIds: {
    key: 'personIds',
    path: '/companies/{companyId}/people/ids',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Id',
      plural: 'Ids',
    },
    operations: {
      list: {
        name: 'internalBorrowersListIds',
        file: 'borrowers',
        hasBody: false,
      },
    },
  },
  personInteractionCallTranscripts: {
    key: 'personInteractionCallTranscripts',
    path: '/people/{personId}/interactions/{interactionId}/call-transcripts',
    scope: 'person',
    pathParams: ['personId', 'interactionId'],
    label: {
      singular: 'Call Transcript',
      plural: 'Call Transcripts',
    },
    idParam: 'aICallTranscriptionResultId',
    operations: {
      list: {
        name: 'callTranscriptionResultsGetByInteraction',
        file: 'interactions',
        hasBody: false,
      },
      get: {
        name: 'callTranscriptionResultsGet',
        file: 'interactions',
        hasBody: false,
      },
      create: {
        name: 'submitCallTranscriptionRequest',
        file: 'interactions',
        hasBody: false,
      },
      update: {
        name: 'callTranscriptionResultsUpdate',
        file: 'interactions',
        hasBody: true,
      },
    },
    formSchemas: {
      response: 'personInteractionCallTranscriptsResponse',
      request: 'personInteractionCallTranscriptsRequest',
    },
  },
  personInteractionCallTranscriptSummaries: {
    key: 'personInteractionCallTranscriptSummaries',
    path: '/people/{personId}/interactions/{interactionId}/call-transcripts/{aICallTranscriptionResultId}/summaries',
    scope: 'person',
    pathParams: ['personId', 'interactionId', 'aICallTranscriptionResultId'],
    label: {
      singular: 'Summary',
      plural: 'Summaries',
    },
    idParam: 'aICallSummaryResultId',
    operations: {
      get: {
        name: 'callSummaryResultsGet',
        file: 'interactions',
        hasBody: false,
      },
      create: {
        name: 'submitCallSummaryRequest',
        file: 'interactions',
        hasBody: false,
      },
      update: {
        name: 'callSummaryResultsUpdate',
        file: 'interactions',
        hasBody: true,
      },
    },
    formSchemas: {
      response: 'personInteractionCallTranscriptSummariesResponse',
      request: 'personInteractionCallTranscriptSummariesRequest',
    },
  },
  personInteractionCallTranscriptSummariesPerson: {
    key: 'personInteractionCallTranscriptSummariesPerson',
    path: '/people/{personId}/interactions/{interactionId}/call-transcripts/summaries',
    scope: 'person',
    pathParams: ['personId', 'interactionId'],
    label: {
      singular: 'Summary',
      plural: 'Summaries',
    },
    operations: {
      list: {
        name: 'callSummaryResultsGetByInteraction',
        file: 'interactions',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'personInteractionCallTranscriptSummariesPersonResponse',
    },
  },
  personInteractionNotes: {
    key: 'personInteractionNotes',
    path: '/people/{personId}/interaction-notes',
    scope: 'person',
    pathParams: ['personId'],
    label: {
      singular: 'Interaction Note',
      plural: 'Interaction Notes',
    },
    operations: {
      list: {
        name: 'listBorrowerInteractionNotes',
        file: 'api-public',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'personInteractionNotesResponse',
    },
  },
  personInteractions: {
    key: 'personInteractions',
    path: '/people/{personId}/interactions',
    scope: 'person',
    pathParams: ['personId'],
    label: {
      singular: 'Interaction',
      plural: 'Interactions',
    },
    idParam: 'interactionId',
    operations: {
      list: {
        name: 'interactionGetAll',
        file: 'interactions',
        hasBody: false,
      },
      get: {
        name: 'interactionGetById',
        file: 'interactions',
        hasBody: false,
      },
      create: {
        name: 'interactionAdd',
        file: 'interactions',
        hasBody: true,
      },
      update: {
        name: 'interactionUpdate',
        file: 'interactions',
        hasBody: true,
      },
      delete: {
        name: 'interactionDelete',
        file: 'interactions',
        hasBody: false,
      },
      actions: [
        {
          name: 'getManyPreviousInteractions',
          file: 'interactions',
          hasBody: false,
        },
        {
          name: 'interactionDownloadRecording',
          file: 'interactions',
          hasBody: false,
        },
        {
          name: 'interactionDownloadVoicemail',
          file: 'interactions',
          hasBody: false,
        },
        {
          name: 'interactionSearch',
          file: 'interactions',
          hasBody: false,
        },
      ],
    },
  },
  personLoanFutureBalances: {
    key: 'personLoanFutureBalances',
    path: '/people/{personId}/loans/{loanId}/future-balances',
    scope: 'loan',
    pathParams: ['personId', 'loanId'],
    label: {
      singular: 'Future Balance',
      plural: 'Future Balances',
    },
    operations: {
      list: {
        name: 'loanFutureBalancesGet',
        file: 'api-public',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'personLoanFutureBalancesResponse',
    },
  },
  personLoanPromiseToPayPlans: {
    key: 'personLoanPromiseToPayPlans',
    path: '/people/{personId}/loans/{loanId}/promise-to-pay-plans',
    scope: 'loan',
    pathParams: ['personId', 'loanId'],
    label: {
      singular: 'Promise To Pay Plan',
      plural: 'Promise To Pay Plans',
    },
    idParam: 'promiseToPayPlanId',
    operations: {
      list: {
        name: 'getPromiseToPayPlansByLoan',
        file: 'promise-to-pay',
        hasBody: false,
      },
      get: {
        name: 'getPromiseToPayPlan',
        file: 'promise-to-pay',
        hasBody: false,
      },
      create: {
        name: 'createPromiseToPayPlan',
        file: 'promise-to-pay',
        hasBody: true,
      },
      actions: [
        {
          name: 'cancelPromiseToPayPlan',
          file: 'promise-to-pay',
          hasBody: true,
        },
        {
          name: 'evaluatePromiseToPayPlan',
          file: 'promise-to-pay',
          hasBody: false,
        },
      ],
    },
    formSchemas: {
      response: 'personLoanPromiseToPayPlansResponse',
      request: 'personLoanPromiseToPayPlansRequest',
    },
  },
  plaidAuthLinkToken: {
    key: 'plaidAuthLinkToken',
    path: '/plaid/auth/link-token',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Link Token',
      plural: 'Link Tokens',
    },
    operations: {
      create: {
        name: 'plaidAuthLinkToken',
        file: 'api-internal',
        hasBody: false,
      },
    },
    companyAmbiguous: true,
  },
  promiseToPayPlans: {
    key: 'promiseToPayPlans',
    path: '/companies/{companyId}/promise-to-pay-plans',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Promise To Pay Plan',
      plural: 'Promise To Pay Plans',
    },
    operations: {
      list: {
        name: 'internalGetPromiseToPayPlansByCompany',
        file: 'promise-to-pay',
        hasBody: false,
      },
      actions: [
        {
          name: 'getPromiseToPayPlansByCompany',
          file: 'promise-to-pay',
          hasBody: false,
        },
      ],
    },
    formSchemas: {
      response: 'promiseToPayPlansResponse',
    },
  },
  promoPrograms: {
    key: 'promoPrograms',
    path: '/companies/{companyId}/people/{personId}/loans/{loanId}/promo-programs',
    scope: 'loan',
    pathParams: ['companyId', 'personId', 'loanId'],
    label: {
      singular: 'Promo Program',
      plural: 'Promo Programs',
    },
    idParam: 'promoProgramId',
    operations: {
      list: {
        name: 'internalPromoProgramsGetAll',
        file: 'promoprogram',
        hasBody: false,
      },
      get: {
        name: 'internalPromoProgramsGet',
        file: 'promoprogram',
        hasBody: false,
      },
      create: {
        name: 'promoProgramsAdd',
        file: 'promoprogram',
        hasBody: true,
      },
      update: {
        name: 'promoProgramsUpdate',
        file: 'promoprogram',
        hasBody: true,
      },
      delete: {
        name: 'promoProgramsDelete',
        file: 'promoprogram',
        hasBody: false,
      },
      actions: [
        {
          name: 'internalPromoProgramsReverse',
          file: 'promoprogram',
          hasBody: false,
        },
        {
          name: 'internalPromoProgramsExerciseDeferredInterest',
          file: 'promoprogram',
          hasBody: false,
        },
        {
          name: 'internalPromoProgramsRecognizeDeferredInterest',
          file: 'promoprogram',
          hasBody: false,
        },
        {
          name: 'internalPromoProgramsEvaluate',
          file: 'promoprogram',
          hasBody: true,
        },
        {
          name: 'promoProgramsGetAll',
          file: 'promoprogram',
          hasBody: false,
        },
        {
          name: 'promoProgramsGet',
          file: 'promoprogram',
          hasBody: false,
        },
        {
          name: 'promoProgramsActivate',
          file: 'promoprogram',
          hasBody: false,
        },
      ],
    },
    formSchemas: {
      response: 'promoProgramsResponse',
      request: 'promoProgramsRequest',
    },
  },
  promoProgramTypes: {
    key: 'promoProgramTypes',
    path: '/companies/{companyId}/promo-program-types',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Promo Program Type',
      plural: 'Promo Program Types',
    },
    idParam: 'promoProgramTypeId',
    operations: {
      list: {
        name: 'internalPromoProgramTypesGetAll',
        file: 'promoprogram',
        hasBody: false,
      },
      get: {
        name: 'internalPromoProgramTypesGet',
        file: 'promoprogram',
        hasBody: false,
      },
      create: {
        name: 'internalPromoProgramTypesAdd',
        file: 'promoprogram',
        hasBody: true,
      },
      update: {
        name: 'internalPromoProgramTypesUpdate',
        file: 'promoprogram',
        hasBody: true,
      },
      delete: {
        name: 'internalPromoProgramTypesDelete',
        file: 'promoprogram',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'promoProgramTypesResponse',
      request: 'promoProgramTypesRequest',
    },
  },
  publishMessage: {
    key: 'publishMessage',
    path: '/publish-message',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Publish Message',
      plural: 'Publish Messages',
    },
    operations: {
      create: {
        name: 'publishMessage',
        file: 'api-internal',
        hasBody: true,
      },
    },
    formSchemas: {
      request: 'publishMessageRequest',
    },
    companyAmbiguous: true,
  },
  purchases: {
    key: 'purchases',
    path: '/companies/{companyId}/people/{personId}/loans/{loanId}/purchases',
    scope: 'loan',
    pathParams: ['companyId', 'personId', 'loanId'],
    label: {
      singular: 'Purchase',
      plural: 'Purchases',
    },
    idParam: 'purchaseId',
    operations: {
      list: {
        name: 'aliasLoanPurchasesGet',
        file: 'api-public',
        hasBody: false,
      },
      get: {
        name: 'internalLocPurchaseGetOne',
        file: 'api-internal',
        hasBody: false,
      },
      actions: [
        {
          name: 'loanPurchasesGet',
          file: 'api-public',
          hasBody: false,
        },
        {
          name: 'locPurchaseGetOne',
          file: 'api-internal',
          hasBody: false,
        },
      ],
    },
    formSchemas: {
      response: 'purchasesResponse',
    },
  },
  purchasesTimeline: {
    key: 'purchasesTimeline',
    path: '/people/{personId}/loans/{loanId}/purchases-timeline',
    scope: 'loan',
    pathParams: ['personId', 'loanId'],
    label: {
      singular: 'Purchases Timeline',
      plural: 'Purchases Timelines',
    },
    operations: {
      list: {
        name: 'loanPurchasesTimelineGet',
        file: 'api-public',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'purchasesTimelineResponse',
    },
  },
  rateCaps: {
    key: 'rateCaps',
    path: '/people/{personId}/loans/{loanId}/rate-caps',
    scope: 'loan',
    pathParams: ['personId', 'loanId'],
    label: {
      singular: 'Rate Cap',
      plural: 'Rate Caps',
    },
    idParam: 'rateCapId',
    operations: {
      list: {
        name: 'loanRateCapsGet',
        file: 'rate-caps',
        hasBody: false,
      },
      create: {
        name: 'loanRateCapAdd',
        file: 'rate-caps',
        hasBody: true,
      },
      update: {
        name: 'loanRateCapUpdate',
        file: 'rate-caps',
        hasBody: true,
      },
      delete: {
        name: 'loanRateCapDelete',
        file: 'rate-caps',
        hasBody: false,
      },
    },
    formSchemas: {
      request: 'rateCapsRequest',
    },
  },
  rates: {
    key: 'rates',
    path: '/companies/{companyId}/people/{personId}/loans/{loanId}/rates',
    scope: 'loan',
    pathParams: ['companyId', 'personId', 'loanId'],
    label: {
      singular: 'Rate',
      plural: 'Rates',
    },
    idParam: 'rateId',
    operations: {
      list: {
        name: 'internalLoanRatesGet',
        file: 'api-internal',
        hasBody: false,
      },
      create: {
        name: 'internalLoanRatesAdd',
        file: 'api-internal',
        hasBody: true,
      },
      update: {
        name: 'loanRatesUpdate',
        file: 'api-public',
        hasBody: true,
      },
      delete: {
        name: 'internalLoanRatesDelete',
        file: 'api-internal',
        hasBody: false,
      },
      actions: [
        {
          name: 'loanRatesGet',
          file: 'api-public',
          hasBody: false,
        },
        {
          name: 'loanRatesAdd',
          file: 'api-public',
          hasBody: true,
        },
        {
          name: 'loanRatesDelete',
          file: 'api-public',
          hasBody: false,
        },
      ],
    },
    formSchemas: {
      response: 'ratesResponse',
      request: 'ratesRequest',
    },
  },
  refunds: {
    key: 'refunds',
    path: '/companies/{companyId}/people/{personId}/loans/{loanId}/refunds',
    scope: 'loan',
    pathParams: ['companyId', 'personId', 'loanId'],
    label: {
      singular: 'Refund',
      plural: 'Refunds',
    },
    idParam: 'loanRefundId',
    operations: {
      list: {
        name: 'internalLoanRefundsGet',
        file: 'api-internal',
        hasBody: false,
      },
      get: {
        name: 'internalLoanRefundsGetOne',
        file: 'api-internal',
        hasBody: false,
      },
      create: {
        name: 'internalLoanRefundsPost',
        file: 'api-internal',
        hasBody: true,
      },
      update: {
        name: 'internalInstallmentRefundUpdate',
        file: 'api-internal',
        hasBody: true,
      },
      actions: [
        {
          name: 'internalLoanRefundsCancel',
          file: 'api-internal',
          hasBody: true,
        },
        {
          name: 'loanRefundsGet',
          file: 'api-public',
          hasBody: false,
        },
        {
          name: 'loanRefundsPost',
          file: 'api-public',
          hasBody: true,
        },
        {
          name: 'loanRefundsCancel',
          file: 'api-public',
          hasBody: true,
        },
      ],
    },
    formSchemas: {
      response: 'refundsResponse',
      request: 'refundsRequest',
    },
  },
  repaymentEngineInfo: {
    key: 'repaymentEngineInfo',
    path: '/companies/{companyId}/loans/{loanId}/repayment-engine-info',
    scope: 'loan',
    pathParams: ['companyId', 'loanId'],
    label: {
      singular: 'Repayment Engine Info',
      plural: 'Repayment Engine Infos',
    },
    operations: {
      list: {
        name: 'getRepaymentEngineInfo',
        file: 'api-internal',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'repaymentEngineInfoResponse',
    },
  },
  repaymentEngineNotifications: {
    key: 'repaymentEngineNotifications',
    path: '/companies/{companyId}/repayment-engine/notifications',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Notification',
      plural: 'Notifications',
    },
    operations: {
      list: {
        name: 'getNotificationTypesByCompany',
        file: 'repayment-engine',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'repaymentEngineNotificationsResponse',
    },
  },
  repaymentEngineProductsWithNotifications: {
    key: 'repaymentEngineProductsWithNotifications',
    path: '/companies/{companyId}/repayment-engine/products-with-notifications',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Products With Notification',
      plural: 'Products With Notifications',
    },
    operations: {
      list: {
        name: 'getProductsWithNotifications',
        file: 'repayment-engine',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'repaymentEngineProductsWithNotificationsResponse',
    },
  },
  repaymentEngineSubjectsWithNotifications: {
    key: 'repaymentEngineSubjectsWithNotifications',
    path: '/companies/{companyId}/repayment-engine/subjects-with-notifications',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Subjects With Notification',
      plural: 'Subjects With Notifications',
    },
    operations: {
      list: {
        name: 'getSubjectsWithNotifications',
        file: 'repayment-engine',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'repaymentEngineSubjectsWithNotificationsResponse',
    },
  },
  repaymentEngineTriggersWithNotifications: {
    key: 'repaymentEngineTriggersWithNotifications',
    path: '/companies/{companyId}/repayment-engine/triggers-with-notifications',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Triggers With Notification',
      plural: 'Triggers With Notifications',
    },
    operations: {
      list: {
        name: 'getTriggersWithNotifications',
        file: 'repayment-engine',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'repaymentEngineTriggersWithNotificationsResponse',
    },
  },
  rolePermissions: {
    key: 'rolePermissions',
    path: '/companies/{companyId}/roles/{roleId}/permissions',
    scope: 'company',
    pathParams: ['companyId', 'roleId'],
    label: {
      singular: 'Permission',
      plural: 'Permissions',
    },
    idParam: 'permissionId',
    operations: {
      create: {
        name: 'companyRolePermissionsElevate',
        file: 'api-internal',
        hasBody: true,
      },
      delete: {
        name: 'companyRolePermissionsRevokeOne',
        file: 'api-internal',
        hasBody: false,
      },
      actions: [
        {
          name: 'companyRolePermissionsRevoke',
          file: 'api-internal',
          hasBody: false,
        },
      ],
    },
    formSchemas: {
      request: 'rolePermissionsRequest',
    },
  },
  roles: {
    key: 'roles',
    path: '/companies/{companyId}/roles',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Role',
      plural: 'Roles',
    },
    idParam: 'roleId',
    operations: {
      list: {
        name: 'companyRoleGetAll',
        file: 'api-internal',
        hasBody: false,
      },
      get: {
        name: 'companyRoleGet',
        file: 'api-internal',
        hasBody: false,
      },
      create: {
        name: 'companyRoleAdd',
        file: 'api-internal',
        hasBody: true,
      },
      update: {
        name: 'companyRoleUpdate',
        file: 'api-internal',
        hasBody: true,
      },
      delete: {
        name: 'companyRoleDelete',
        file: 'api-internal',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'rolesResponse',
      request: 'rolesRequest',
    },
  },
  routingNumbers: {
    key: 'routingNumbers',
    path: '/routing-numbers',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Routing Number',
      plural: 'Routing Numbers',
    },
    idParam: 'routingNumber',
    operations: {
      get: {
        name: 'getRoutingNumber',
        file: 'api-internal',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'routingNumbersResponse',
    },
    companyAmbiguous: true,
  },
  rpcCompanies: {
    key: 'rpcCompanies',
    path: '/rpc/companies',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Company',
      plural: 'Companies',
    },
    operations: {
      actions: [
        {
          name: 'emitScheduledInteractionEvents',
          file: 'api-internal',
          hasBody: false,
        },
        {
          name: 'emitExpiredCaseSnoozeEvents',
          file: 'api-internal',
          hasBody: false,
        },
        {
          name: 'emitExpiredCaseDniEvents',
          file: 'api-internal',
          hasBody: false,
        },
      ],
    },
    companyAmbiguous: true,
  },
  scheduleOptions: {
    key: 'scheduleOptions',
    path: '/companies/{companyId}/people/{personId}/loans/{loanId}/schedule-options',
    scope: 'loan',
    pathParams: ['companyId', 'personId', 'loanId'],
    label: {
      singular: 'Schedule Option',
      plural: 'Schedule Options',
    },
    operations: {
      list: {
        name: 'internalLoanScheduleOptionsGet',
        file: 'api-internal',
        hasBody: false,
      },
      actions: [
        {
          name: 'loanScheduleOptionsGet',
          file: 'api-public',
          hasBody: false,
        },
      ],
    },
    formSchemas: {
      response: 'scheduleOptionsResponse',
    },
  },
  sendgridWebhookChargebackReport: {
    key: 'sendgridWebhookChargebackReport',
    path: '/sendgrid/webhooks/chargeback-report',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Chargeback Report',
      plural: 'Chargeback Reports',
    },
    operations: {
      create: {
        name: 'chargebackReportPost',
        file: 'api-internal',
        hasBody: true,
      },
    },
    companyAmbiguous: true,
  },
  snapshotMissing: {
    key: 'snapshotMissing',
    path: '/companies/{companyId}/snapshots/missing',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Missing',
      plural: 'Missings',
    },
    operations: {
      list: {
        name: 'getMissingSnapshots',
        file: 'api-internal',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'snapshotMissingResponse',
    },
  },
  state: {
    key: 'state',
    path: '/companies/{companyId}/people/{personId}/loans/{loanId}/state',
    scope: 'loan',
    pathParams: ['companyId', 'personId', 'loanId'],
    label: {
      singular: 'State',
      plural: 'States',
    },
    operations: {
      list: {
        name: 'loanStateGet',
        file: 'api-internal',
        hasBody: false,
      },
      create: {
        name: 'loanStatePost',
        file: 'api-internal',
        hasBody: false,
      },
    },
  },
  statements: {
    key: 'statements',
    path: '/companies/{companyId}/people/{personId}/loans/{loanId}/statements',
    scope: 'loan',
    pathParams: ['companyId', 'personId', 'loanId'],
    label: {
      singular: 'Statement',
      plural: 'Statements',
    },
    idParam: 'statementId',
    operations: {
      list: {
        name: 'internalGetStatements',
        file: 'api-internal',
        hasBody: false,
      },
      update: {
        name: 'updateStatement',
        file: 'statements',
        hasBody: true,
      },
      delete: {
        name: 'deleteStatement',
        file: 'api-internal',
        hasBody: false,
      },
      actions: [
        {
          name: 'getStatements',
          file: 'statements',
          hasBody: false,
        },
        {
          name: 'internalSaveAutopay',
          file: 'api-internal',
          hasBody: false,
        },
        {
          name: 'getStatementDetails',
          file: 'statements',
          hasBody: false,
        },
      ],
    },
    formSchemas: {
      response: 'statementsResponse',
      request: 'statementsRequest',
    },
  },
  statementWithoutPdf: {
    key: 'statementWithoutPdf',
    path: '/companies/{companyId}/statements/without-pdf',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Without Pdf',
      plural: 'Without Pdfs',
    },
    operations: {
      list: {
        name: 'internalGetCompanyStatementsWithoutPdf',
        file: 'api-internal',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'statementWithoutPdfResponse',
    },
  },
  supercaseBulkOperationMemberBulkOperationResults: {
    key: 'supercaseBulkOperationMemberBulkOperationResults',
    path: '/supercases/{supercaseId}/bulk-operations/{supercaseBulkOperationId}/member-bulk-operation-results',
    scope: 'global',
    pathParams: ['supercaseId', 'supercaseBulkOperationId'],
    label: {
      singular: 'Member Bulk Operation Result',
      plural: 'Member Bulk Operation Results',
    },
    idParam: 'populationMembershipId',
    operations: {
      list: {
        name: 'getMemberBulkOperationResultsByOperation',
        file: 'supercases',
        hasBody: false,
      },
      update: {
        name: 'updateMemberBulkOperationResult',
        file: 'supercases',
        hasBody: true,
      },
    },
    formSchemas: {
      response: 'supercaseBulkOperationMemberBulkOperationResultsResponse',
      request: 'supercaseBulkOperationMemberBulkOperationResultsRequest',
    },
  },
  supercaseBulkOperations: {
    key: 'supercaseBulkOperations',
    path: '/supercases/{supercaseId}/bulk-operations',
    scope: 'global',
    pathParams: ['supercaseId'],
    label: {
      singular: 'Bulk Operation',
      plural: 'Bulk Operations',
    },
    idParam: 'supercaseBulkOperationId',
    operations: {
      list: {
        name: 'supercaseBulkOperationList',
        file: 'supercases',
        hasBody: false,
      },
      get: {
        name: 'supercaseBulkOperationGet',
        file: 'supercases',
        hasBody: false,
      },
      update: {
        name: 'supercaseBulkOperationUpdate',
        file: 'supercases',
        hasBody: true,
      },
      actions: [
        {
          name: 'supercaseBulkOperationSearch',
          file: 'supercases',
          hasBody: false,
        },
      ],
    },
  },
  supercaseBulkOperationTargetPopulations: {
    key: 'supercaseBulkOperationTargetPopulations',
    path: '/supercases/{supercaseId}/bulk-operations/{supercaseBulkOperationId}/target-populations',
    scope: 'global',
    pathParams: ['supercaseId', 'supercaseBulkOperationId'],
    label: {
      singular: 'Target Population',
      plural: 'Target Populations',
    },
    operations: {
      list: {
        name: 'getBulkOperationTargetPopulations',
        file: 'supercases',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'supercaseBulkOperationTargetPopulationsResponse',
    },
  },
  supercaseGlobalNotes: {
    key: 'supercaseGlobalNotes',
    path: '/supercases/{supercaseId}/global-notes',
    scope: 'global',
    pathParams: ['supercaseId'],
    label: {
      singular: 'Global Note',
      plural: 'Global Notes',
    },
    idParam: 'noteId',
    operations: {
      list: {
        name: 'globalNoteList',
        file: 'supercases',
        hasBody: false,
      },
      get: {
        name: 'globalNoteGet',
        file: 'supercases',
        hasBody: false,
      },
      create: {
        name: 'globalNoteCreate',
        file: 'supercases',
        hasBody: true,
      },
      update: {
        name: 'globalNoteUpdate',
        file: 'supercases',
        hasBody: true,
      },
    },
    formSchemas: {
      response: 'supercaseGlobalNotesResponse',
      request: 'supercaseGlobalNotesRequest',
    },
  },
  supercaseNotes: {
    key: 'supercaseNotes',
    path: '/supercases/{supercaseId}/notes',
    scope: 'global',
    pathParams: ['supercaseId'],
    label: {
      singular: 'Note',
      plural: 'Notes',
    },
    idParam: 'noteId',
    operations: {
      list: {
        name: 'privateNoteList',
        file: 'supercases',
        hasBody: false,
      },
      get: {
        name: 'privateNoteGet',
        file: 'supercases',
        hasBody: false,
      },
      create: {
        name: 'privateNoteCreate',
        file: 'supercases',
        hasBody: true,
      },
      update: {
        name: 'privateNoteUpdate',
        file: 'supercases',
        hasBody: true,
      },
    },
    formSchemas: {
      response: 'supercaseNotesResponse',
      request: 'supercaseNotesRequest',
    },
  },
  supercasePopulationDraft: {
    key: 'supercasePopulationDraft',
    path: '/supercases/{supercaseId}/populations/draft',
    scope: 'global',
    pathParams: ['supercaseId'],
    label: {
      singular: 'Draft',
      plural: 'Drafts',
    },
    operations: {
      list: {
        name: 'draftPopulationGet',
        file: 'supercases',
        hasBody: false,
      },
      actions: [
        {
          name: 'draftPopulationCommit',
          file: 'supercases',
          hasBody: false,
        },
      ],
    },
    formSchemas: {
      response: 'supercasePopulationDraftResponse',
    },
  },
  supercasePopulationDraftMembers: {
    key: 'supercasePopulationDraftMembers',
    path: '/supercases/{supercaseId}/populations/draft/members',
    scope: 'global',
    pathParams: ['supercaseId'],
    label: {
      singular: 'Member',
      plural: 'Members',
    },
    operations: {
      list: {
        name: 'draftPopulationMembersList',
        file: 'supercases',
        hasBody: false,
      },
      create: {
        name: 'draftPopulationMembersAdd',
        file: 'supercases',
        hasBody: true,
      },
      update: {
        name: 'draftPopulationMembersSet',
        file: 'supercases',
        hasBody: true,
      },
      actions: [
        {
          name: 'draftPopulationMembersListCsv',
          file: 'supercases',
          hasBody: false,
        },
        {
          name: 'draftPopulationMembersSetCsv',
          file: 'supercases',
          hasBody: true,
        },
        {
          name: 'draftPopulationMembersAddCsv',
          file: 'supercases',
          hasBody: true,
        },
      ],
    },
  },
  supercasePopulations: {
    key: 'supercasePopulations',
    path: '/supercases/{supercaseId}/populations',
    scope: 'global',
    pathParams: ['supercaseId'],
    label: {
      singular: 'Population',
      plural: 'Populations',
    },
    idParam: 'populationId',
    operations: {
      list: {
        name: 'populationList',
        file: 'supercases',
        hasBody: false,
      },
      get: {
        name: 'populationGet',
        file: 'supercases',
        hasBody: false,
      },
      update: {
        name: 'populationUpdate',
        file: 'supercases',
        hasBody: true,
      },
      actions: [
        {
          name: 'populationMembersList',
          file: 'supercases',
          hasBody: false,
        },
        {
          name: 'populationBulkSendMessage',
          file: 'supercases',
          hasBody: true,
        },
        {
          name: 'committedMembersListCsv',
          file: 'supercases',
          hasBody: false,
        },
        {
          name: 'populationMembersListCsv',
          file: 'supercases',
          hasBody: false,
        },
      ],
    },
    formSchemas: {
      response: 'supercasePopulationsResponse',
      request: 'supercasePopulationsRequest',
    },
  },
  supercases: {
    key: 'supercases',
    path: '/companies/{companyId}/supercases',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Supercase',
      plural: 'Supercases',
    },
    idParam: 'supercaseId',
    operations: {
      list: {
        name: 'internalSupercaseList',
        file: 'supercases',
        hasBody: false,
      },
      get: {
        name: 'supercaseGet',
        file: 'supercases',
        hasBody: false,
      },
      create: {
        name: 'internalSupercaseCreate',
        file: 'supercases',
        hasBody: true,
      },
      update: {
        name: 'supercaseUpdate',
        file: 'supercases',
        hasBody: true,
      },
      actions: [
        {
          name: 'supercaseList',
          file: 'supercases',
          hasBody: false,
        },
        {
          name: 'supercaseCreate',
          file: 'supercases',
          hasBody: true,
        },
        {
          name: 'getSupercaseDocuments',
          file: 'supercases',
          hasBody: false,
        },
        {
          name: 'setSupercaseDocuments',
          file: 'supercases',
          hasBody: true,
        },
        {
          name: 'addSupercaseDocuments',
          file: 'supercases',
          hasBody: true,
        },
        {
          name: 'supercaseBulkUpdate',
          file: 'supercases',
          hasBody: true,
        },
        {
          name: 'supercaseBulkSendMessage',
          file: 'supercases',
          hasBody: true,
        },
        {
          name: 'supercaseBulkCreateDni',
          file: 'supercases',
          hasBody: true,
        },
        {
          name: 'supercaseBulkDeleteDni',
          file: 'supercases',
          hasBody: false,
        },
        {
          name: 'supercaseCaseCount',
          file: 'supercases',
          hasBody: false,
        },
        {
          name: 'supercaseMembersTemplateCsv',
          file: 'supercases',
          hasBody: false,
        },
      ],
    },
    formSchemas: {
      response: 'supercasesResponse',
      request: 'supercasesRequest',
    },
  },
  taskWorkerPairingConfigDefault: {
    key: 'taskWorkerPairingConfigDefault',
    path: '/companies/{companyId}/task-worker-pairing-configs/default',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Default',
      plural: 'Defaults',
    },
    operations: {
      list: {
        name: 'taskWorkerPairingConfigDefaultGet',
        file: 'twilio-tasks',
        hasBody: false,
      },
      update: {
        name: 'taskWorkerPairingConfigDefaultUpdate',
        file: 'twilio-tasks',
        hasBody: true,
      },
    },
    formSchemas: {
      response: 'taskWorkerPairingConfigDefaultResponse',
      request: 'taskWorkerPairingConfigDefaultRequest',
    },
  },
  taskWorkerPairingConfigs: {
    key: 'taskWorkerPairingConfigs',
    path: '/companies/{companyId}/task-worker-pairing-configs',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Task Worker Pairing Config',
      plural: 'Task Worker Pairing Configs',
    },
    idParam: 'taskWorkerPairingConfigId',
    operations: {
      list: {
        name: 'taskWorkerPairingConfigList',
        file: 'twilio-tasks',
        hasBody: false,
      },
      get: {
        name: 'taskWorkerPairingConfigGet',
        file: 'twilio-tasks',
        hasBody: false,
      },
      create: {
        name: 'taskWorkerPairingConfigCreate',
        file: 'twilio-tasks',
        hasBody: true,
      },
      update: {
        name: 'taskWorkerPairingConfigUpdate',
        file: 'twilio-tasks',
        hasBody: true,
      },
      delete: {
        name: 'taskWorkerPairingConfigDelete',
        file: 'twilio-tasks',
        hasBody: false,
      },
      actions: [
        {
          name: 'taskWorkerPairingConfigSync',
          file: 'twilio-tasks',
          hasBody: false,
        },
      ],
    },
    formSchemas: {
      response: 'taskWorkerPairingConfigsResponse',
      request: 'taskWorkerPairingConfigsRequest',
    },
  },
  teams: {
    key: 'teams',
    path: '/companies/{companyId}/teams',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Team',
      plural: 'Teams',
    },
    idParam: 'teamId',
    operations: {
      list: {
        name: 'internalTeamsGet',
        file: 'employees',
        hasBody: false,
      },
      get: {
        name: 'internalTeamGet',
        file: 'employees',
        hasBody: false,
      },
      create: {
        name: 'internalTeamsCreate',
        file: 'employees',
        hasBody: true,
      },
      update: {
        name: 'internalTeamUpdate',
        file: 'employees',
        hasBody: true,
      },
      delete: {
        name: 'internalTeamDelete',
        file: 'employees',
        hasBody: false,
      },
      actions: [
        {
          name: 'teamsGet',
          file: 'employees',
          hasBody: false,
        },
        {
          name: 'teamGet',
          file: 'employees',
          hasBody: false,
        },
        {
          name: 'teamsCreate',
          file: 'employees',
          hasBody: true,
        },
        {
          name: 'teamUpdate',
          file: 'employees',
          hasBody: true,
        },
        {
          name: 'teamDelete',
          file: 'employees',
          hasBody: false,
        },
      ],
    },
    formSchemas: {
      response: 'teamsResponse',
      request: 'teamsRequest',
    },
  },
  transactionAutoTransition: {
    key: 'transactionAutoTransition',
    path: '/companies/{companyId}/transactions/auto-transition',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Auto Transition',
      plural: 'Auto Transitions',
    },
    operations: {
      list: {
        name: 'companyTransactionsGetTransitional',
        file: 'transactions-internal',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'transactionAutoTransitionResponse',
    },
  },
  transactionChargebacks: {
    key: 'transactionChargebacks',
    path: '/companies/{companyId}/people/{personId}/loans/{loanId}/transactions/{transactionId}/chargebacks',
    scope: 'loan',
    pathParams: ['companyId', 'personId', 'loanId', 'transactionId'],
    label: {
      singular: 'Chargeback',
      plural: 'Chargebacks',
    },
    idParam: 'chargebackId',
    operations: {
      get: {
        name: 'aliasGetChargebackById',
        file: 'transactions-public',
        hasBody: false,
      },
      create: {
        name: 'aliasTransactionChargeback',
        file: 'transactions-public',
        hasBody: true,
      },
      update: {
        name: 'aliasUpdateChargeback',
        file: 'transactions-public',
        hasBody: true,
      },
      actions: [
        {
          name: 'getChargebackById',
          file: 'transactions-public',
          hasBody: false,
        },
        {
          name: 'transactionChargeback',
          file: 'transactions-public',
          hasBody: true,
        },
        {
          name: 'updateChargeback',
          file: 'transactions-public',
          hasBody: true,
        },
      ],
    },
    formSchemas: {
      response: 'transactionChargebacksResponse',
      request: 'transactionChargebacksRequest',
    },
  },
  transactionExpiredHoldDays: {
    key: 'transactionExpiredHoldDays',
    path: '/transactions/expired-hold-days',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Expired Hold Day',
      plural: 'Expired Hold Days',
    },
    operations: {
      list: {
        name: 'transactionsGetAllExpiredHoldDays',
        file: 'transactions-internal',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'transactionExpiredHoldDaysResponse',
    },
    companyAmbiguous: true,
  },
  transactionInitiated: {
    key: 'transactionInitiated',
    path: '/transactions/initiated',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Initiated',
      plural: 'Initiateds',
    },
    operations: {
      list: {
        name: 'transactionsGetInitiatedAchInternal',
        file: 'transactions-internal',
        hasBody: false,
      },
      create: {
        name: 'transactionsUpdateInitiatedAchInternal',
        file: 'transactions-internal',
        hasBody: true,
      },
    },
    formSchemas: {
      response: 'transactionInitiatedResponse',
      request: 'transactionInitiatedRequest',
    },
    companyAmbiguous: true,
  },
  transactionMicrodeposits: {
    key: 'transactionMicrodeposits',
    path: '/transactions/microdeposits',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Microdeposit',
      plural: 'Microdeposits',
    },
    operations: {
      list: {
        name: 'microdepositsGetScheduledInternal',
        file: 'transactions-internal',
        hasBody: false,
      },
      create: {
        name: 'transactionsUpdateMicrodepositsInternal',
        file: 'transactions-internal',
        hasBody: true,
      },
      actions: [
        {
          name: 'microdepositsSendReminders',
          file: 'transactions-internal',
          hasBody: true,
        },
      ],
    },
    formSchemas: {
      response: 'transactionMicrodepositsResponse',
    },
    companyAmbiguous: true,
  },
  transactions: {
    key: 'transactions',
    path: '/companies/{companyId}/people/{personId}/loans/{loanId}/transactions',
    scope: 'loan',
    pathParams: ['companyId', 'personId', 'loanId'],
    label: {
      singular: 'Transaction',
      plural: 'Transactions',
    },
    idParam: 'transactionId',
    operations: {
      list: {
        name: 'aliasLoanTransactionsGetAll',
        file: 'transactions-public',
        hasBody: false,
      },
      get: {
        name: 'aliasTransactionsGetById',
        file: 'transactions-public',
        hasBody: false,
      },
      create: {
        name: 'internalTransactionsCreate',
        file: 'transactions-public',
        hasBody: true,
      },
      update: {
        name: 'aliasTransactionsUpdate',
        file: 'transactions-public',
        hasBody: true,
      },
      actions: [
        {
          name: 'transactionsBackdateForDeadzone',
          file: 'transactions-internal',
          hasBody: false,
        },
        {
          name: 'transactionsDeleteChildren',
          file: 'transactions-internal',
          hasBody: false,
        },
        {
          name: 'transactionsZeroSplits',
          file: 'transactions-internal',
          hasBody: false,
        },
        {
          name: 'aliasTransactionCancel',
          file: 'transactions-public',
          hasBody: false,
        },
        {
          name: 'aliasTransactionReverse',
          file: 'transactions-public',
          hasBody: true,
        },
        {
          name: 'aliasGetChargebacks',
          file: 'transactions-public',
          hasBody: false,
        },
        {
          name: 'aliasTransactionsFailMultiple',
          file: 'transactions-public',
          hasBody: true,
        },
        {
          name: 'loanTransactionsGetAll',
          file: 'transactions-public',
          hasBody: false,
        },
        {
          name: 'transactionsGetById',
          file: 'transactions-public',
          hasBody: false,
        },
        {
          name: 'transactionsCreate',
          file: 'transactions-public',
          hasBody: true,
        },
        {
          name: 'transactionsUpdate',
          file: 'transactions-public',
          hasBody: true,
        },
        {
          name: 'transactionCancel',
          file: 'transactions-public',
          hasBody: false,
        },
        {
          name: 'transactionReverse',
          file: 'transactions-public',
          hasBody: true,
        },
        {
          name: 'getChargebacks',
          file: 'transactions-public',
          hasBody: false,
        },
        {
          name: 'transactionBackdate',
          file: 'transactions-public',
          hasBody: true,
        },
        {
          name: 'transactionsFailMultiple',
          file: 'transactions-public',
          hasBody: true,
        },
      ],
    },
    formSchemas: {
      response: 'transactionsResponse',
    },
  },
  twilioAnswerQueuedCall: {
    key: 'twilioAnswerQueuedCall',
    path: '/twilio/answer-queued-call',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Answer Queued Call',
      plural: 'Answer Queued Calls',
    },
    operations: {
      create: {
        name: 'answerQueuedCall',
        file: 'twilio',
        hasBody: true,
      },
    },
    formSchemas: {
      request: 'twilioAnswerQueuedCallRequest',
    },
    companyAmbiguous: true,
  },
  twilioAuthAccessTokens: {
    key: 'twilioAuthAccessTokens',
    path: '/twilio/auth/access-tokens',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Access Token',
      plural: 'Access Tokens',
    },
    operations: {
      create: {
        name: 'getMultiAccessTokens',
        file: 'twilio',
        hasBody: false,
      },
    },
    companyAmbiguous: true,
  },
  twilioAuthBorrowerAccessTokens: {
    key: 'twilioAuthBorrowerAccessTokens',
    path: '/twilio/auth/borrower-access-tokens',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Borrower Access Token',
      plural: 'Borrower Access Tokens',
    },
    operations: {
      create: {
        name: 'getBorrowerMultiAccessTokens',
        file: 'twilio',
        hasBody: false,
      },
    },
    companyAmbiguous: true,
  },
  twilioAuthVoiceToken: {
    key: 'twilioAuthVoiceToken',
    path: '/twilio/auth/voice-token',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Voice Token',
      plural: 'Voice Tokens',
    },
    operations: {
      create: {
        name: 'getVoiceAccessToken',
        file: 'twilio',
        hasBody: false,
      },
    },
    companyAmbiguous: true,
  },
  twilioBorrowerCloseWebchat: {
    key: 'twilioBorrowerCloseWebchat',
    path: '/twilio/borrower-close-webchat',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Borrower Close Webchat',
      plural: 'Borrower Close Webchats',
    },
    operations: {
      create: {
        name: 'handleCloseBorrowerWebchat',
        file: 'twilio',
        hasBody: true,
      },
    },
    formSchemas: {
      request: 'twilioBorrowerCloseWebchatRequest',
    },
    companyAmbiguous: true,
  },
  twilioBorrowerGetActiveWebchat: {
    key: 'twilioBorrowerGetActiveWebchat',
    path: '/twilio/borrower-get-active-webchat',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Borrower Get Active Webchat',
      plural: 'Borrower Get Active Webchats',
    },
    operations: {
      list: {
        name: 'handleGetActiveBorrowerWebchat',
        file: 'twilio',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'twilioBorrowerGetActiveWebchatResponse',
    },
    companyAmbiguous: true,
  },
  twilioBorrowerReportAgentDisconnect: {
    key: 'twilioBorrowerReportAgentDisconnect',
    path: '/twilio/borrower-report-agent-disconnect',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Borrower Report Agent Disconnect',
      plural: 'Borrower Report Agent Disconnects',
    },
    operations: {
      create: {
        name: 'handleBorrowerReportAgentDisconnect',
        file: 'twilio',
        hasBody: false,
      },
    },
    companyAmbiguous: true,
  },
  twilioBorrowerStartWebchat: {
    key: 'twilioBorrowerStartWebchat',
    path: '/twilio/borrower-start-webchat',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Borrower Start Webchat',
      plural: 'Borrower Start Webchats',
    },
    operations: {
      create: {
        name: 'handleStartBorrowerWebchat',
        file: 'twilio',
        hasBody: true,
      },
    },
    formSchemas: {
      request: 'twilioBorrowerStartWebchatRequest',
    },
    companyAmbiguous: true,
  },
  twilioCloseConvo: {
    key: 'twilioCloseConvo',
    path: '/twilio/close-convo',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Close Convo',
      plural: 'Close Convos',
    },
    operations: {
      create: {
        name: 'closeConvo',
        file: 'twilio',
        hasBody: true,
      },
    },
    formSchemas: {
      request: 'twilioCloseConvoRequest',
    },
    companyAmbiguous: true,
  },
  twilioForcePublishTask: {
    key: 'twilioForcePublishTask',
    path: '/twilio/force-publish-task',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Force Publish Task',
      plural: 'Force Publish Tasks',
    },
    operations: {
      create: {
        name: 'forcePublishTask',
        file: 'twilio-tasks',
        hasBody: true,
      },
    },
    formSchemas: {
      request: 'twilioForcePublishTaskRequest',
    },
    companyAmbiguous: true,
  },
  twilioJoinConvo: {
    key: 'twilioJoinConvo',
    path: '/twilio/join-convo',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Join Convo',
      plural: 'Join Convos',
    },
    operations: {
      create: {
        name: 'joinConvo',
        file: 'twilio',
        hasBody: true,
      },
    },
    formSchemas: {
      request: 'twilioJoinConvoRequest',
    },
    companyAmbiguous: true,
  },
  twilioMakeOutboundVoiceParams: {
    key: 'twilioMakeOutboundVoiceParams',
    path: '/twilio/make-outbound-voice-params',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Make Outbound Voice Param',
      plural: 'Make Outbound Voice Params',
    },
    operations: {
      create: {
        name: 'makeOutboundVoiceParams',
        file: 'twilio',
        hasBody: true,
      },
    },
    formSchemas: {
      request: 'twilioMakeOutboundVoiceParamsRequest',
    },
    companyAmbiguous: true,
  },
  twilioPlayBeepOnUserConsentAndStartRecording: {
    key: 'twilioPlayBeepOnUserConsentAndStartRecording',
    path: '/twilio/play-beep-on-user-consent-and-start-recording',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Play Beep On User Consent And Start Recording',
      plural: 'Play Beep On User Consent And Start Recordings',
    },
    operations: {
      create: {
        name: 'playBeepOnUserConsentAndStartRecording',
        file: 'twilio',
        hasBody: false,
      },
    },
    companyAmbiguous: true,
  },
  twilioQueues: {
    key: 'twilioQueues',
    path: '/companies/{companyId}/twilio-queues',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Twilio Queue',
      plural: 'Twilio Queues',
    },
    operations: {
      list: {
        name: 'getAllQueues',
        file: 'twilio-tasks',
        hasBody: false,
      },
    },
  },
  twilioSyncTaskHistory: {
    key: 'twilioSyncTaskHistory',
    path: '/twilio/sync-task-history',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Sync Task History',
      plural: 'Sync Task Histories',
    },
    operations: {
      create: {
        name: 'syncTaskHistory',
        file: 'twilio',
        hasBody: true,
      },
    },
    formSchemas: {
      request: 'twilioSyncTaskHistoryRequest',
    },
    companyAmbiguous: true,
  },
  twilioTasktypeAvailability: {
    key: 'twilioTasktypeAvailability',
    path: '/twilio/tasktype-availability',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Tasktype Availability',
      plural: 'Tasktype Availabilities',
    },
    operations: {
      list: {
        name: 'getTasktypeAvailability',
        file: 'twilio-tasks',
        hasBody: false,
      },
      update: {
        name: 'updateTasktypeAvailability',
        file: 'twilio-tasks',
        hasBody: true,
      },
    },
    formSchemas: {
      response: 'twilioTasktypeAvailabilityResponse',
      request: 'twilioTasktypeAvailabilityRequest',
    },
    companyAmbiguous: true,
  },
  twilioTerminatedTasks: {
    key: 'twilioTerminatedTasks',
    path: '/companies/{companyId}/twilio-terminated-tasks',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Twilio Terminated Task',
      plural: 'Twilio Terminated Tasks',
    },
    idParam: 'taskHistoryId',
    operations: {
      list: {
        name: 'taskHistoryList',
        file: 'twilio-tasks',
        hasBody: false,
      },
      get: {
        name: 'taskHistoryGet',
        file: 'twilio-tasks',
        hasBody: false,
      },
      actions: [
        {
          name: 'taskHistoryClone',
          file: 'twilio-tasks',
          hasBody: false,
        },
      ],
    },
  },
  twilioUnterminatedTasks: {
    key: 'twilioUnterminatedTasks',
    path: '/companies/{companyId}/twilio-unterminated-tasks',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Twilio Unterminated Task',
      plural: 'Twilio Unterminated Tasks',
    },
    idParam: 'taskSid',
    operations: {
      list: {
        name: 'listUnterminatedTasks',
        file: 'twilio-tasks',
        hasBody: false,
      },
      get: {
        name: 'readUnterminatedTask',
        file: 'twilio-tasks',
        hasBody: false,
      },
      delete: {
        name: 'deleteUnterminatedTask',
        file: 'twilio-tasks',
        hasBody: false,
      },
      actions: [
        {
          name: 'deleteUnterminatedTasks',
          file: 'twilio-tasks',
          hasBody: true,
        },
        {
          name: 'abandonAcceptedTask',
          file: 'twilio-tasks',
          hasBody: false,
        },
        {
          name: 'reflowUnterminatedTasks',
          file: 'twilio-tasks',
          hasBody: false,
        },
      ],
    },
    formSchemas: {
      response: 'twilioUnterminatedTasksResponse',
    },
  },
  twilioUpdateBorrowerHoldStatus: {
    key: 'twilioUpdateBorrowerHoldStatus',
    path: '/twilio/update-borrower-hold-status',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Update Borrower Hold Status',
      plural: 'Update Borrower Hold Statuses',
    },
    operations: {
      create: {
        name: 'updateBorrowerHoldStatus',
        file: 'twilio',
        hasBody: true,
      },
    },
    formSchemas: {
      request: 'twilioUpdateBorrowerHoldStatusRequest',
    },
    companyAmbiguous: true,
  },
  twilioUpdateVoiceCall: {
    key: 'twilioUpdateVoiceCall',
    path: '/twilio/update-voice-call',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Update Voice Call',
      plural: 'Update Voice Calls',
    },
    operations: {
      create: {
        name: 'updateVoiceCall',
        file: 'twilio',
        hasBody: true,
      },
    },
    formSchemas: {
      request: 'twilioUpdateVoiceCallRequest',
    },
    companyAmbiguous: true,
  },
  twilioWebhookCallStatus: {
    key: 'twilioWebhookCallStatus',
    path: '/twilio/webhooks/call-status',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Call Status',
      plural: 'Call Statuses',
    },
    operations: {
      create: {
        name: 'webhookCallStatus',
        file: 'twilio',
        hasBody: true,
      },
    },
    companyAmbiguous: true,
  },
  twilioWebhookConferenceStatus: {
    key: 'twilioWebhookConferenceStatus',
    path: '/twilio/webhooks/conference-status',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Conference Status',
      plural: 'Conference Statuses',
    },
    operations: {
      create: {
        name: 'webhookConferenceStatus',
        file: 'twilio',
        hasBody: true,
      },
    },
    companyAmbiguous: true,
  },
  twilioWebhookIncomingMessage: {
    key: 'twilioWebhookIncomingMessage',
    path: '/twilio/webhooks/incoming-message',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Incoming Message',
      plural: 'Incoming Messages',
    },
    operations: {
      create: {
        name: 'webhookIncomingMessage',
        file: 'twilio',
        hasBody: true,
      },
    },
    companyAmbiguous: true,
  },
  twilioWebhookOutboundVoice: {
    key: 'twilioWebhookOutboundVoice',
    path: '/twilio/webhooks/outbound-voice',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Outbound Voice',
      plural: 'Outbound Voices',
    },
    operations: {
      create: {
        name: 'webhookVoiceDupe',
        file: 'twilio',
        hasBody: true,
      },
    },
    companyAmbiguous: true,
  },
  twilioWebhookPerConversationEvent: {
    key: 'twilioWebhookPerConversationEvent',
    path: '/twilio/webhooks/per-conversation-event',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Per Conversation Event',
      plural: 'Per Conversation Events',
    },
    operations: {
      create: {
        name: 'webhookPerConversationEvent',
        file: 'twilio',
        hasBody: true,
      },
    },
    companyAmbiguous: true,
  },
  twilioWebhookRecordingStatus: {
    key: 'twilioWebhookRecordingStatus',
    path: '/twilio/webhooks/recording-status',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Recording Status',
      plural: 'Recording Statuses',
    },
    operations: {
      create: {
        name: 'webhookRecordingStatus',
        file: 'twilio',
        hasBody: true,
      },
    },
    companyAmbiguous: true,
  },
  twilioWebhookTaskAssignment: {
    key: 'twilioWebhookTaskAssignment',
    path: '/twilio/webhooks/task-assignment',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Task Assignment',
      plural: 'Task Assignments',
    },
    operations: {
      create: {
        name: 'webhookTaskAssignment',
        file: 'twilio',
        hasBody: true,
      },
    },
    companyAmbiguous: true,
  },
  twilioWebhookTaskrouterEvents: {
    key: 'twilioWebhookTaskrouterEvents',
    path: '/twilio/webhooks/taskrouter-events',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Taskrouter Event',
      plural: 'Taskrouter Events',
    },
    operations: {
      create: {
        name: 'webhookTaskrouterEvents',
        file: 'twilio',
        hasBody: true,
      },
    },
    companyAmbiguous: true,
  },
  twilioWebhookVoice: {
    key: 'twilioWebhookVoice',
    path: '/twilio/webhooks/voice',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Voice',
      plural: 'Voices',
    },
    operations: {
      create: {
        name: 'webhookVoice',
        file: 'twilio',
        hasBody: true,
      },
    },
    companyAmbiguous: true,
  },
  twilioWebhookVoicemailCompleted: {
    key: 'twilioWebhookVoicemailCompleted',
    path: '/twilio/webhooks/voicemail-completed',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Voicemail Completed',
      plural: 'Voicemail Completeds',
    },
    operations: {
      create: {
        name: 'webhookVoicemailCompleted',
        file: 'twilio',
        hasBody: true,
      },
    },
    companyAmbiguous: true,
  },
  twilioWebhookVoicemailStatus: {
    key: 'twilioWebhookVoicemailStatus',
    path: '/twilio/webhooks/voicemail-status',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Voicemail Status',
      plural: 'Voicemail Statuses',
    },
    operations: {
      create: {
        name: 'webhookVoicemailStatus',
        file: 'twilio',
        hasBody: true,
      },
    },
    companyAmbiguous: true,
  },
  twilioWebhookWebhookPlayBeepTwiml: {
    key: 'twilioWebhookWebhookPlayBeepTwiml',
    path: '/twilio/webhooks/webhook-play-beep-twiml',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Webhook Play Beep Twiml',
      plural: 'Webhook Play Beep Twimls',
    },
    operations: {
      create: {
        name: 'webhookPlayBeepTwiml',
        file: 'twilio',
        hasBody: false,
      },
    },
    companyAmbiguous: true,
  },
  twilioWorkers: {
    key: 'twilioWorkers',
    path: '/companies/{companyId}/twilio-workers',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Twilio Worker',
      plural: 'Twilio Workers',
    },
    operations: {
      list: {
        name: 'listWorkers',
        file: 'twilio-tasks',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'twilioWorkersResponse',
    },
  },
  uscountyAddressesinCounty: {
    key: 'uscountyAddressesinCounty',
    path: '/uscounties/{state}/{fipsCode}/addressesinCounty',
    scope: 'global',
    pathParams: ['state', 'fipsCode'],
    label: {
      singular: 'Addressesin County',
      plural: 'Addressesin Counties',
    },
    operations: {
      list: {
        name: 'getAddressesInFipsCode',
        file: 'api-internal',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'uscountyAddressesinCountyResponse',
    },
  },
  userRoles: {
    key: 'userRoles',
    path: '/companies/{companyId}/users/{userId}/roles',
    scope: 'company',
    pathParams: ['companyId', 'userId'],
    label: {
      singular: 'Role',
      plural: 'Roles',
    },
    idParam: 'roleId',
    operations: {
      list: {
        name: 'internalUserRoleGet',
        file: 'users',
        hasBody: false,
      },
      update: {
        name: 'internalUserRoleUpdate',
        file: 'users',
        hasBody: false,
      },
      delete: {
        name: 'internalUserRoleDelete',
        file: 'users',
        hasBody: false,
      },
      actions: [
        {
          name: 'userRoleGet',
          file: 'users',
          hasBody: false,
        },
        {
          name: 'userRoleUpdate',
          file: 'users',
          hasBody: false,
        },
        {
          name: 'userRoleDelete',
          file: 'users',
          hasBody: false,
        },
      ],
    },
    formSchemas: {
      response: 'userRolesResponse',
    },
  },
  users: {
    key: 'users',
    path: '/companies/{companyId}/users',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'User',
      plural: 'Users',
    },
    idParam: 'userId',
    operations: {
      list: {
        name: 'internalUsersGet',
        file: 'users',
        hasBody: false,
      },
      get: {
        name: 'internalUserGet',
        file: 'users',
        hasBody: false,
      },
      create: {
        name: 'internalUserCreate',
        file: 'users',
        hasBody: true,
      },
      update: {
        name: 'internalUserUpdate',
        file: 'users',
        hasBody: true,
      },
      actions: [
        {
          name: 'internalUserAuthReplace',
          file: 'security',
          hasBody: true,
        },
        {
          name: 'internalUserGetPermissions',
          file: 'users',
          hasBody: false,
        },
        {
          name: 'usersGet',
          file: 'users',
          hasBody: false,
        },
        {
          name: 'userGet',
          file: 'users',
          hasBody: false,
        },
        {
          name: 'userCreate',
          file: 'users',
          hasBody: true,
        },
        {
          name: 'userUpdate',
          file: 'users',
          hasBody: true,
        },
        {
          name: 'userAuthReplace',
          file: 'security',
          hasBody: true,
        },
        {
          name: 'userGetPermissions',
          file: 'users',
          hasBody: false,
        },
      ],
    },
    formSchemas: {
      response: 'usersResponse',
      request: 'usersRequest',
      updateRequest: 'usersUpdateRequest',
    },
  },
  v2CommunicatorTemplates: {
    key: 'v2CommunicatorTemplates',
    path: '/v2/companies/{companyId}/communicator/templates',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Template',
      plural: 'Templates',
    },
    operations: {
      list: {
        name: 'internalListTemplateVersionsModern',
        file: 'communicator',
        hasBody: false,
      },
      actions: [
        {
          name: 'listTemplateVersionsModern',
          file: 'communicator',
          hasBody: false,
        },
      ],
    },
    formSchemas: {
      response: 'v2CommunicatorTemplatesResponse',
    },
  },
  verificationQuestions: {
    key: 'verificationQuestions',
    path: '/companies/{companyId}/verification-questions',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Verification Question',
      plural: 'Verification Questions',
    },
    operations: {
      list: {
        name: 'internalBorrowerVerificationQuestionsGetAll',
        file: 'borrower-verifications',
        hasBody: false,
      },
      actions: [
        {
          name: 'borrowerVerificationQuestionsGetAll',
          file: 'borrower-verifications',
          hasBody: false,
        },
      ],
    },
    formSchemas: {
      response: 'verificationQuestionsResponse',
    },
  },
  verifications: {
    key: 'verifications',
    path: '/people/{personId}/verifications',
    scope: 'person',
    pathParams: ['personId'],
    label: {
      singular: 'Verification',
      plural: 'Verifications',
    },
    idParam: 'verificationId',
    operations: {
      list: {
        name: 'borrowerVerificationGetAll',
        file: 'borrower-verifications',
        hasBody: false,
      },
      get: {
        name: 'borrowerVerificationGet',
        file: 'borrower-verifications',
        hasBody: false,
      },
      create: {
        name: 'borrowerVerificationCreate',
        file: 'borrower-verifications',
        hasBody: true,
      },
      actions: [
        {
          name: 'borrowerVerificationAnswerAttemptCreate',
          file: 'borrower-verifications',
          hasBody: true,
        },
      ],
    },
    formSchemas: {
      response: 'verificationsResponse',
      request: 'verificationsRequest',
    },
  },
  verificationTypes: {
    key: 'verificationTypes',
    path: '/companies/{companyId}/verification-types',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Verification Type',
      plural: 'Verification Types',
    },
    idParam: 'verificationTypeId',
    operations: {
      list: {
        name: 'internalBorrowerVerificationTypesGetAll',
        file: 'borrower-verifications',
        hasBody: false,
      },
      get: {
        name: 'internalBorrowerVerificationTypesGetOne',
        file: 'borrower-verifications',
        hasBody: false,
      },
      create: {
        name: 'internalBorrowerVerificationTypesCreate',
        file: 'borrower-verifications',
        hasBody: true,
      },
      update: {
        name: 'internalBorrowerVerificationTypesUpdate',
        file: 'borrower-verifications',
        hasBody: true,
      },
      actions: [
        {
          name: 'borrowerVerificationTypesGetAll',
          file: 'borrower-verifications',
          hasBody: false,
        },
        {
          name: 'borrowerVerificationTypesGetOne',
          file: 'borrower-verifications',
          hasBody: false,
        },
        {
          name: 'borrowerVerificationTypesCreate',
          file: 'borrower-verifications',
          hasBody: true,
        },
        {
          name: 'borrowerVerificationTypesUpdate',
          file: 'borrower-verifications',
          hasBody: true,
        },
      ],
    },
    formSchemas: {
      response: 'verificationTypesResponse',
      request: 'verificationTypesRequest',
    },
  },
  workflowStepTypes: {
    key: 'workflowStepTypes',
    path: '/companies/{companyId}/workflow-step-types',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Workflow Step Type',
      plural: 'Workflow Step Types',
    },
    idParam: 'workflowStepTypeId',
    operations: {
      list: {
        name: 'getWorkflowStepTypes',
        file: 'workflows',
        hasBody: false,
      },
      get: {
        name: 'getWorkflowStepTypeById',
        file: 'workflows',
        hasBody: false,
      },
      create: {
        name: 'createWorkflowStepType',
        file: 'workflows',
        hasBody: true,
      },
      update: {
        name: 'updateWorkflowStepType',
        file: 'workflows',
        hasBody: true,
      },
      delete: {
        name: 'deleteWorkflowStepType',
        file: 'workflows',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'workflowStepType',
    },
  },
  workflowTypes: {
    key: 'workflowTypes',
    path: '/companies/{companyId}/workflow-types',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Workflow Type',
      plural: 'Workflow Types',
    },
    idParam: 'workflowTypeId',
    operations: {
      list: {
        name: 'getWorkflowTypes',
        file: 'workflows',
        hasBody: false,
      },
      get: {
        name: 'getWorkflowTypeById',
        file: 'workflows',
        hasBody: false,
      },
      create: {
        name: 'createWorkflowType',
        file: 'workflows',
        hasBody: true,
      },
      update: {
        name: 'updateWorkflowType',
        file: 'workflows',
        hasBody: true,
      },
      delete: {
        name: 'deleteWorkflowType',
        file: 'workflows',
        hasBody: false,
      },
      actions: [
        {
          name: 'exportWorkflowTypes',
          file: 'workflows',
          hasBody: false,
        },
        {
          name: 'importWorkflowTypes',
          file: 'workflows',
          hasBody: true,
        },
      ],
    },
    formSchemas: {
      response: 'workflowType',
    },
  },
  workflowWorkitemTypes: {
    key: 'workflowWorkitemTypes',
    path: '/companies/{companyId}/workflow-workitem-types',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Workflow Workitem Type',
      plural: 'Workflow Workitem Types',
    },
    idParam: 'workflowWorkitemTypeId',
    operations: {
      list: {
        name: 'getWorkitemTypes',
        file: 'workflows',
        hasBody: false,
      },
      get: {
        name: 'getWorkitemTypeById',
        file: 'workflows',
        hasBody: false,
      },
      create: {
        name: 'createWorkitemType',
        file: 'workflows',
        hasBody: true,
      },
      update: {
        name: 'updateWorkitemType',
        file: 'workflows',
        hasBody: true,
      },
      delete: {
        name: 'deleteWorkitemType',
        file: 'workflows',
        hasBody: false,
      },
    },
    formSchemas: {
      response: 'workflowItemType',
    },
  },
  zendeskSsoSharedSecret: {
    key: 'zendeskSsoSharedSecret',
    path: '/companies/{companyId}/zendesk/sso-shared-secret',
    scope: 'company',
    pathParams: ['companyId'],
    label: {
      singular: 'Sso Shared Secret',
      plural: 'Sso Shared Secrets',
    },
    operations: {
      create: {
        name: 'setSsoSharedSecret',
        file: 'api-internal',
        hasBody: true,
      },
    },
  },
  zendeskSsoToken: {
    key: 'zendeskSsoToken',
    path: '/zendesk/sso-token',
    scope: 'global',
    pathParams: [],
    label: {
      singular: 'Sso Token',
      plural: 'Sso Tokens',
    },
    operations: {
      list: {
        name: 'getSsoToken',
        file: 'api-internal',
        hasBody: false,
      },
    },
    companyAmbiguous: true,
  },
}
